/* lua.js generated code 0.3.0 */

let { DCShareShowError } = require("./DCConst")
var LoginBuffer = require("clover/loader/LoginBuffer")
const dcUtil = require("../../entry/dc")
DCAssist = table()
var AppController = AppController || table()
if (__IOS) {
    AppController = oc.HeAppController
}
DCAssist.init = function () {
    DCAssist.isNewUser = false
    DCAssist.endLevel()
}
DCAssist.heartbeatInterval = 5 * 60
DCAssist.dcForGameLoading = function (step, isNewUser) {
    var interval = new Date().getTime() - dcUtil.getDCStartTime();
    if (isNewUser == undefined) {
        dc.dcGameLoading_5(VIRAL_ID, step, interval);
    } else {
        dc.dcGameLoading_5(VIRAL_ID, step, isNewUser, interval);
    }
}

DCAssist.paramsUtil = function (params) {
    for (var k in params) {
        var v = params[k]
        if (v && v.__isLuaTable) {
            params[k] = JSON.stringify($tableToObj(v))
        }else if (cc.isObject(v)) {
            params[k] = JSON.stringify(v)
        }else {
            params[k] = tostring(v)
        }
    }
    return params
}
DCAssist.getSceneSystem = function () {
    if (DCAssist.isInGaming) {
        var current_system = LevelType.getLevelTypeByLevelId(DCAssist.level) || 0
        if (current_system === GameLevelType.kMainLevel) {
            return "main_stage"
        } else if (current_system === GameLevelType.kHiddenLevel) {
            return "branch_stage"
        }
    }
    return "home_scence"
}
DCAssist.getSNS_ID = function () {
    var pfName = DCAssist.getLastLoginName()
    if (type(pfName) === "string") {
        if (pfName === "guest") {
            return "guest_"
        } else {
            var openData = Localhost.getSnsUserInfo()
            if (type(openData) === "table" && type(openData.openid) === "string") {
                return pfName + "_" + openData.openid
            }
        }
    }
    return ""
}
DCAssist.getLastLoginName = function () {
    var name = PlatformConfig.getPlatformAuthName(Localhost.getLastLoginOauthID())
    if (!name || name === "") {
        name = PlatformConfig.getPlatformAuthName(LoginBuffer.getInstance().getOAuthType())
        if (!name || name === "") {
            name = "guest"
        }
    }
    return name
}
DCAssist.dcAttackCommonData = function (map, current_stage, current_system, session) {
    if (map && type(map) === "table") {
        map.uid = map.uid || UserManager.getInstance().uid
        if (!map.uid) {
            // var [sidx, eidx] = string.find(string.lower(tostring(map.uid)), "%D")
            // var [sidx, eidx] = string.lower(tostring(map.uid)).match(/\d/g)
            // if (sidx) {
            map.uid = "12345"
            // }
        }
        map.high_stage = map.high_stage || UserManager.getInstance().getUserRef().getTopLevelId()
        map.level = map.high_stage;
        map.yellow_star_total = map.yellow_star_total || UserManager.getInstance().getUserRef().getYellowStar()
        map.orange_star_total = map.orange_star_total || UserManager.getInstance().getUserRef().getOrangeStar()
        map.blue_star_total = map.blue_star_total || UserManager.getInstance().getUserRef().getBlueStar()
        map.current_stage = map.current_stage || current_stage || (DCAssist.isInGaming && DCAssist.level || 0) || 0
        map.current_system = map.current_system || current_system || DCAssist.getSceneSystem() || "home_scence"
        map.session = map.session || session || (DCAssist.isInGaming && DCAssist.playLevelSession || 0) || 0
    }
}
DCAssist.dcConvert2CurrentSystem = function (source) {
    source = source || ""
    var scene = cc.Director.getInstance().getRunningScene()
    if (source === "" || source === "0" || !scene) {
        return "home_scence"
    }
    if (scene.name === "GameScene" || scene.name === "ReplayGameScene") {
        // WARN: maybe multi result
        return DCAssist.getSceneSystem()
    } else if (scene.name === "HomeScene") {
        var bool = null
        if (source === ModuleName.FRIENDS) {
            bool = true
        } else if (source === ModuleName.FRIENDS_FREE_GIFT) {
            bool = true
            // FIXME: string find
            // } else if (string.find(source, )) {
        } else if (source.indexOf(ModuleName.FRIENDS_INVITE) !== -1) {
            bool = true
        }
        if (bool) {
            return "friends_book"
        }
    }
    return "home_scence"
}
DCAssist.setPlayLevelSession = function(session){
    if (session){
        // cc.log("setPlayLevelSession 恢复session ",session)
        DCAssist.playLevelSession = session
    }else{
        DCAssist.playLevelSession = UserManager.getInstance().uid + "_" + formatDate(new Date, "yyMMddHHmm")
    }
}
DCAssist.startLevel = function (gameLogic) {
    DCAssist.isInGaming = true
    DCAssist.gameLogic = gameLogic
    DCAssist.level = DCAssist.gameLogic.level
    DCAssist.originalLvlId = DCAssist.gameLogic.originalLvlId
    // DCAssist.playLevelSession = UserManager.getInstance().uid + "_" + Localhost.dateExact()
    // Localhost.dateExact有问题，改为formateDate
    // DCAssist.playLevelSession = UserManager.getInstance().uid + "_" + formatDate(new Date, "yyMMddHHmm")
    DCAssist.playLevelClock = Localhost.timeInSec()
    DCAssist.propsBuyList = table()
    DCAssist.dcForPickCocoParams = table()
    DCAssist.dcForStartGameParams = table()
}
DCAssist.endLevel = function () {
    DCAssist.isInGaming = null
    DCAssist.level = 0
    DCAssist.originalLvlId = 0
    DCAssist.gameLogic = null
    DCAssist.playLevelSession = 0
    DCAssist.playLevelClock = 0
    DCAssist.propsBuyList = table()
    DCAssist.dcForPickCocoParams = DCAssist.dcForStartGameParams;
    DCAssist.dcForStartGameParams = table()
}

/**
 * 打关数据
 * @param {number}type 1：成功通关，2：失败，3：自动恢复关卡，4：主动退出
 */
DCAssist.dcForStageRecord = function(type, replay) {
    if (replay == null)
        replay = DCAssist.gameLogic? DCAssist.gameLogic.replay: null
    if (replay != null) {
        let formatter = DCAssist._formatter
        if (formatter == null) {
            const ReplayDataFormatter = require("clover/data/Replay/ReplayDataFormatter")
            formatter = new ReplayDataFormatter()
            DCAssist._formatter = formatter
        }
        let formattedValue = formatter.format(replay) 
        let info = {
            level: replay.level,
            seed: replay.randomSeed,
            record:  JSON.stringify(formattedValue),
            type: type
        }

        DCAssist.userTrack("stage", "stage_record", info)
    }
}

DCAssist.buyPropSuccess = function (propID) {
    propID = tostring(propID)
    if (!DCAssist.isInGaming) {
        return
    }
    if (!DCAssist.propsBuyList[propID]) {
        DCAssist.propsBuyList[propID] = 0
    }
    DCAssist.propsBuyList[propID] = DCAssist.propsBuyList[propID] + 1
}
function getActivityStageState(level) {
    // var
    let ret = -1
    let key = "activity_play_" + level
    let hasPlay = tonumber(UserLocalSettings.getSetting(key, -1)) || -1
    if (window.NegotiatorManager) {
        // var	
        let mgr = window.NegotiatorManager.getInstance()
        let min = mgr.getStartLevelID()
        let max = min + mgr.getMaxLevelCount() - 1
        let info = mgr.amInfo
        if (level >= min && level <= max && info) {
            // check state
            if (level === max) {
                if (info.topLevelStatus !== 0) {
                    ret = 3
                } else if (hasPlay) {
                    ret = 2
                } else {
                    ret = 1
                }
            } else if (hasPlay > 0) {
                let topLevel = info.topLevel
                if (level < topLevel) {
                    ret = 3
                } else {
                    ret = 2
                }
            } else {
                ret = 1
            }
        }
    }
    // local 
    UserLocalSettings.setSetting(key, 1)
    return ret
}
DCAssist.dcForStartGame = function (isReplaying,itemList,logic) {
    if (!DCAssist.isInGaming) {
        return
    }
    var originalLvlId = DCAssist.originalLvlId
    var level = DCAssist.level
    var event
    if (originalLvlId && originalLvlId > 0 && level < 0){
        level = originalLvlId
        event = "baidu"
        console.log("@@@@add startgame event baidu original:"+originalLvlId)
    }
    var score = UserScore.getInstance().getScore(level)
    var params = table()

    if (isReplaying) {
        params.is_replaying = true
    }
    params.session = DCAssist.playLevelSession
    var pre_props = UserLevel.getInstance().currentLevel || table()
    pre_props = pre_props.initProps || table()
    var item = pre_props[GamePropsType.kSuperBird_b]
    params.front_item_10008 = item && item > 0 && 1 || 0
    item = pre_props[GamePropsType.kLine_Wrap_b]
    params.front_item_10009 = item && item > 0 && 1 || 0
    item = pre_props[GamePropsType.kAdd3_b]
    params.front_item_10011 = item && item > 0 && 1 || 0
    params.old_star = score.star
    params.current_stage = level
    let levelMode = LevelConfigManager.getInstance().getLevelGameMode(params.current_stage)
    params.stage_mode = DCAssist.gameLogic.config.gameMode || 0
    var key = "LastNew"
    var lastNew = tonumber(UserLocalSettings.getSetting(key, 0)) || 0
    var lastSystem = LevelType.getLevelTypeByLevelId(lastNew)
    params.stage_state = 0
    params.isopen = 0
    let daSchemeCfg = DAManager.getInstance().getCurrentSchemeCfg()
    if (daSchemeCfg) {
        params.isopen = daSchemeCfg.dcName
    }
    let current_system = LevelType.getLevelTypeByLevelId(DCAssist.level)
    if (current_system === GameLevelType.kMainLevel) {
        if (lastSystem === GameLevelType.kMainLevel || lastNew === 0) {
            if (!UserScore.getInstance().hasScore(level) && tonumber(level) > lastNew) {
                params.stage_state = 1
                UserLocalSettings.setSetting(key, tonumber(level))
            } else {
                params.stage_state = 2
                if (score.star > 0) {
                    params.stage_state = 3
                }
            }
        } else {
            UserLocalSettings.setSetting(key, tonumber(UserManager.getInstance().getUserRef().getTopLevelId()))
        }
        // 202206掉落干预增加字段
        if ((_G.DAUserDataV2 && _G.DAUserDataV2.getInstance().isOpen === true)) {
            if (DAManager.getInstance().finalSchemaTypeForDC) {
                params.isopen = DAManager.getInstance().finalSchemaTypeForDC
            }
            if (DAManager.getInstance().test_para2ForDC) {
                params.var1 = DAManager.getInstance().test_para2ForDC
            }
            if (DAManager.getInstance().test_para3ForDC) {
                params.var2 = DAManager.getInstance().test_para3ForDC
            }
            if (DAManager.getInstance().test_para6ForDC) {
                params.var3 = DAManager.getInstance().test_para6ForDC
            }
            if (DAManager.getInstance().test_para9ForDC) {
                params.var4 = DAManager.getInstance().test_para9ForDC
            }
            if (DAManager.getInstance().test_para5ForDC) {
                params.var5 = DAManager.getInstance().test_para5ForDC
            }
            if (DAManager.getInstance().finalSchema >= 0) {
                params.type = DAManager.getInstance().finalSchema
            }
            if (DAManager.getInstance().difficultyTagForDC) {
                params.record = DAManager.getInstance().difficultyTagForDC + "_new"
            }
            if (DAManager.getInstance().last_paraForDC) {
                params.pf = DAManager.getInstance().last_paraForDC
            }
        }
        current_system = "main_stage"
    }else if (current_system === GameLevelType.kMysteryIsland){
        params.stage_state = 2;
        if(UserManager.getInstance().isFirstPassTopLevel(level)) {
            params.stage_state = 1;
        }
    } else {
        current_system = "home_scence"
    }
    if (params.stage_state == 3){
        let digest = LevelConfigManager.getInstance().getLevelDigest(score.levelId)
        let starMax = $len((digest && digest.scoreTargets || table())) || 3
        if (score.star >= starMax){
            params.state = -1
        }else {
            let isUseAddItem = false
            for (const key in itemList) {
                if (itemList[key] == GamePropsType.kComplementStar || itemList[key] == GamePropsType.kComplementStar2){
                    isUseAddItem = true
                }
            }
            params.state = isUseAddItem ? 1 : 0
        }

    }
    if (LevelType.getLevelTypeByLevelId(DCAssist.level) == GameLevelType.kMysteryIsland){
        let mysteryInfo = MysteryIslandManager.getInstance().getLevelInfo()
        params.t1 = mysteryInfo.levelNo
        params.patition = mysteryInfo.randomColor

    }
    // let purpleManager = PurpleAmyMagicManager.getInstance()
    // if (purpleManager.isUseByLevel(level) && purpleManager.getInfo().streakBuff > 0){
    //     params.levelid = purpleManager.getInfo().streakBuff
    // }
    DCAssist.purpleAmyMagic_streakBuff = 0;
    if (logic && logic.actPreProp && logic.actPreProp.purpleAmyMagic && logic.actPreProp.purpleAmyMagic.streakBuff){
        if (tonumber(logic.actPreProp.purpleAmyMagic.streakBuff) > 0){
            params.levelid = tonumber(logic.actPreProp.purpleAmyMagic.streakBuff)
            DCAssist.purpleAmyMagic_streakBuff = params.levelid
            
            DCAssist.purpleAmyMagic_streaklv = PurpleAmyMagicManager.getInstance().getInfo().streaklv || 0;
            params.use_num = DCAssist.purpleAmyMagic_streaklv
        }
    }

    if (event) {
        params.event = event
    }
    const isHardLevel = LevelConfigManager.getInstance().getHardLevel(level);
    params.stage_diff = isHardLevel ? "1" : "0";
    // 超鸟
    if (NuclearBirdManager.getInstance().isOpenFlag){
        let nulearBirdData = NuclearBirdManager.getInstance().getData()
        params.super_bird_status = NuclearBirdManager.getInstance().isRunNuclear ? 1 :0
        params.act_id = nulearBirdData.getSeasonId()
        params.energy_level = NuclearBirdManager.getInstance().dcEnergyLevel
        params.super_bird_round = nulearBirdData.getTriggerRound()
    }

    DCAssist.dcAttackCommonData(params, null, current_system)
    dc.dcUserTrack_101("stage_start", "", DCAssist.paramsUtil(params))
    DCAssist.dcForStartGameParams = params
    LevelCollectManager.getInstance().dcStageStart(params.current_stage)
    SalvageGiftManager.getInstance().dcSalvageGiftStage("stage_start", params.session, {
        current_stage: params.current_stage
    })
}
DCAssist.dcForEndGame = function (result, attachData) {
    if (!DCAssist.isInGaming) {
        return
    }
    
    var originalLvlId = DCAssist.originalLvlId
    var level = DCAssist.level
    var event
    if (originalLvlId && originalLvlId > 0 && level < 0){
        level = originalLvlId
        event = "baidu"
        console.log("@@@@add end event baidu original:"+originalLvlId)
    }

    let score = UserScore.getInstance().getScore(level)
    let params = table()
    params.session = DCAssist.dcForStartGameParams.session
    params.stage_state = DCAssist.dcForStartGameParams.stage_state
    params.front_item_10008 = DCAssist.dcForStartGameParams.front_item_10008
    params.front_item_10009 = DCAssist.dcForStartGameParams.front_item_10009
    params.front_item_10011 = DCAssist.dcForStartGameParams.front_item_10011
    params.stage_diff = DCAssist.dcForStartGameParams.stage_diff
    params.result = result
    params.s_time = Math.floor(Localhost.timeInSec() - DCAssist.playLevelClock)
    params.score = DCAssist.gameLogic.getTotalScore()
    params.old_star = DCAssist.dcForStartGameParams.old_star
    params.current_stage = level
    let levelMode = LevelConfigManager.getInstance().getLevelGameMode(params.current_stage)
    params.level_star = score.star
    params.mission_id = 0
    params.t1 = level
    params.stage_mode = playTypeValue2Key(DCAssist.dcForStartGameParams.stage_mode);
    params.stage_time = params.s_time
    params.current_star = params.level_star
    if (DCAssist.gameLogic && DCAssist.gameLogic.gameMode && DCAssist.gameLogic.gameMode.getScoreStarLevel && type(DCAssist.gameLogic.gameMode.getScoreStarLevel) === "function") {
        params.current_star = DCAssist.gameLogic.gameMode.getScoreStarLevel()
    }
    params.left_moves = -1
    if (params.result === 2 && DCAssist.gameLogic && DCAssist.gameLogic.getTheCurMovesCache && type(DCAssist.gameLogic.getTheCurMovesCache) === "function") {
        params.left_moves = DCAssist.gameLogic.getTheCurMovesCache()
    }
    if (params.result === 2 && UserManager.getInstance().reachTopLevel() && ChampionLogic.getInstance().dcGetAssignLevel() == level){//通关且为冠军赛指定关卡
        params.seed = "champion_race"
        console.log("champion_race seed")
    }
    if (params.result === 2 && UserManager.getInstance().reachTopLevel() && LightningRushManager.getInstance().isAssignedLevel(level)){//通关且为萌萌闯关指定关卡
        params.seed = "lightening_rush"
        console.log("lightening_rush seed")
    }
    params.target_num = ""
    params.complete_num = ""
    if (DCAssist.gameLogic) {
        if (DCAssist.gameLogic.levelType === GameLevelType.kMainLevel) {
            params.t2 = DATargetCounterV2.getInstance().getTargetCountFormatStr()
            if ((_G.DAUserDataV2 && _G.DAUserDataV2.getInstance().isOpen === true)) {
                if (DAManager.getInstance().finalSchemaTypeForDC) {
                    params.isopen = DAManager.getInstance().finalSchemaTypeForDC
                }
                if (DAManager.getInstance().test_para9ForDC) {
                    params.var4 = DAManager.getInstance().test_para9ForDC
                }
                if (DAManager.getInstance().fuuuReached === true) {
                    params.var1 = "y"
                } else {
                    params.var1 = "n"
                }
                if (DAManager.getInstance().finalSchema >= 0) {
                    params.type = DAManager.getInstance().finalSchema
                }
                if (DCAssist.gameLogic.replaySteps) {
                    for(var i = 1; i < DCAssist.gameLogic.replaySteps.length; i++){
                        if (DCAssist.gameLogic.replaySteps[i].prop != undefined){
                            params.var2 = "y"
                            break;
                        }
                        params.var2 = "n"
                    }
                    
                    // // let sum = 0
                    // for (let k in DCAssist.gameLogic.useItems) {
                    //     let v = DCAssist.gameLogic.useItems[k]
                    //     if ($null(v)) continue
                    //     if (tonumber(v)) {
                    //         sum = sum + tonumber(v)
                    //     }
                    // }
                    // if (sum > 0) {
                    //     params.var2 = "y"
                    // } else {
                    //     params.var2 = "n"
                    // }
                }
                if (DATargetCounterV2.getInstance().getCurrentTargetCount()) {
                    params.var3 = DATargetCounterV2.getInstance().getCurrentTargetCount()
                }
            }
            params.fuuu = DAManager.getInstance().generalStrongFuuuReached && 1 || 0
        }
        if (DCAssist.gameLogic.theGamePlayType === GamePlayType.kBoss) {
            var bossMode = DCAssist.gameLogic.gameMode
            if (bossMode && bossMode.bossList && type(bossMode.bossList) === "table") {
                for (var i = 1, v = bossMode.bossList[1]; v; i++ , v = bossMode.bossList[i]) {
                    if (type(v) === "table") {
                        if (params.target_num !== "") {
                            params.target_num = params.target_num + "_"
                        }
                        params.target_num = params.target_num + (v.hp || "0")
                        if (params.complete_num !== "") {
                            params.complete_num = params.complete_num + "_"
                        }
                        params.complete_num = params.complete_num + ((v.hp || 0) - (v.current_hp || 0))
                    }
                }
            }
        } else if (DCAssist.gameLogic.theOrderList && type(DCAssist.gameLogic.theOrderList) === "table") {
            for (var i = 1, v = DCAssist.gameLogic.theOrderList[1]; v; i++ , v = DCAssist.gameLogic.theOrderList[i]) {
                if (params.target_num !== "") {
                    params.target_num = params.target_num + "_"
                }
                params.target_num = params.target_num + v.targetNum
                if (params.complete_num !== "") {
                    params.complete_num = params.complete_num + "_"
                }
                params.complete_num = params.complete_num + v.ownNum
            }
        }
    }
    if (event)
        params.event = event

    // 掉落优化计数统计
    params.complete_list = DATargetCounter.getInstance().getTargetCountFormatStr()
    let lvmd5 = ResManager.getLevelMd5(DCAssist.level); // he.ResManager.getInstance().getFileMd5("meta/level/" + DCAssist.level + ".inf")
    params.version = lvmd5
    if (params.isopen != undefined) {
        // 已经在上面应为202206掉落干预打过这个字段了
    } else {
        // isopen记录掉落干预强度
        params.isopen = 0
        let daSchemeCfg = DAManager.getInstance().getCurrentSchemeCfg()
        if (daSchemeCfg && DAManager.getInstance().hasIntervened) {
            params.isopen = daSchemeCfg.dcName
        }
    }
    if (LevelType.getLevelTypeByLevelId(DCAssist.level) == GameLevelType.kMysteryIsland){
        let mysteryInfo = MysteryIslandManager.getInstance().getLevelInfo()
        params.t1 = mysteryInfo.levelNo
        params.patition = mysteryInfo.randomColor

    }
    // let purpleManager = PurpleAmyMagicManager.getInstance()
    if (DCAssist.purpleAmyMagic_streakBuff > 0){
        const streakBuff = DCAssist.purpleAmyMagic_streakBuff;
        params.levelid = streakBuff;
        let use_num = 0;
        if (params.result === 2){
            params.num = streakBuff + 1 
            params.num = params.num > 4 ? 4 : params.num
            const streaklv =  DCAssist.purpleAmyMagic_streaklv || 0
            use_num = streaklv + 1;
        }else{
            params.num = 0
        }
        params.use_num = use_num;
    }
    if (DCAssist.gameLogic){
        if (DCAssist.gameLogic.bonusTimeOffset && DCAssist.gameLogic.speedBonusTimeBefore){
            params.pf = DCAssist.gameLogic.speedBonusTimeBefore + "_" + DCAssist.gameLogic.bonusTimeOffset 
        }
        params.score_origin = DCAssist.gameLogic.scoreBonusTimeBefore || 0
    }
    // 版面重排次数（不包括使用道具的主动重排）
    params.refresh = DAManager.getInstance().getPassiveRefreshCount()
    // 超鸟
    if (NuclearBirdManager.getInstance().isOpenFlag){
        let nulearBirdData = NuclearBirdManager.getInstance().getData()
        params.super_bird_status = NuclearBirdManager.getInstance().isRunNuclear ? 1 :0
        params.act_id = nulearBirdData.getSeasonId()
        params.energy_level = NuclearBirdManager.getInstance().dcEnergyLevel
        params.super_bird_round = nulearBirdData.getTriggerRound()
        let state = NuclearBirdManager.getInstance().getData().getInfo().state
        if (state == NuclearBirdManager.STATE.wait_active) {
            if (LevelType.isMysteryIslandLevel(level) || UserManager.getInstance().playMaxLevelNotReachTopLevel(level)){
                NuclearBirdManager.getInstance().dcNuclearBirdNormal("task_in_progress", DCAssist.dcForStartGameParams.session,{
                    stage_num: nulearBirdData.getTargetNum(),
                    current_stage: level,
                    num: tonumber(nulearBirdData.getPassNum())+1
                })
            }
        }
    }
    DCAssist.dcAttackCommonData(params, null, DCAssist.dcForStartGameParams.current_system)
    dc.dcUserTrack_101("stage_end", "", DCAssist.paramsUtil(params))

    DCAssist.dcForEffectEliminate(result)
    SecretCodeManager.getInstance().dcPlayStage(result == 2 ? 2 : 1, params.session, level);
    SalvageGiftManager.getInstance().dcSalvageGiftStage("stage_end", params.session, {
        current_stage: params.current_stage,
        info: params.result
    })
}
DCAssist.dcForErrorGameReplay = function (replay, level) {
    var params = table()
    params.replay = he.HeMathUtils.base64Encode(replay, string.len(replay))
    params.ver = _G.bundleVersion
    params.md5 = he.ResManager.getInstance().getCurVersion()
    params.uid = UserManager.getInstance().uid
    params.time = Localhost.timeInSec()
    params.level = level
    dc.dcUserTrack_101("replay", "force_upload_replay", DCAssist.paramsUtil(params))
}
DCAssist.dcForAllGameReplay = function (replay) {
    var params = table()
    params.replay = he.HeMathUtils.base64Encode(replay, string.len(replay))
    params.ver = _G.bundleVersion
    params.md5 = he.ResManager.getInstance().getCurVersion()
    params.uid = UserManager.getInstance().uid
    params.time = Localhost.timeInSec()
    dc.dcUserTrack_101("replay", "game_all_replay", DCAssist.paramsUtil(params))
}
const DATA_9_ITEMIDS = ['10001', '10002', '10003', '10004', '10005', '10006'];  // 9号点需要记录的道具id
DCAssist.dcForUserDataUpdate = function () {
    var params = table()
    params.energy = UserEnergy.getInstance().getEnergyLimit()
    params.time_lastlogin = tonumber(Localhost.getLastLoginTime())
    params.login_num = Math.max(UserManager.getInstance().getContinueLoginDays() || 0, RecallManager.getInstance().getContinueCount())
    params.friends_invite = UserManager.getInstance().getUserExtendRef().inviteFriendCount || 0
    if (!CacheManager.getInstance().dc4UserDataUpdatePreTimeUsed) {
        CacheManager.getInstance().dc4UserDataUpdatePreTimeUsed = true
        params.time_lastlogin = tonumber(CacheManager.getInstance().getPreLoginTime())
    }
    var lastDate = os.date("*t", params.time_lastlogin)
    var currentDate = os.date("*t", tonumber(Localhost.timeInSec()))
    he_log_info(params.time_lastlogin)
    he_log_info("lastLogin:" + table.tostring(lastDate))
    he_log_info("currLogin:" + table.tostring(currentDate))
    if (params.time_lastlogin !== 0 && lastDate.year === currentDate.year && lastDate.month === currentDate.month && lastDate.day === currentDate.day) {
        return
    }
    // var props = table()
    // var $var36 = GamePropsType.kRefresh, $limit37 = GamePropsType.kHammer_t
    // for (var i = $var36; i <= $limit37; i += 1) {
    //     props[tostring(i)] = 0
    // }
    // for (var i = 1, v = UserManager.getInstance().props[1]; v; i++ , v = UserManager.getInstance().props[i]) {
    //     if (props[tostring(v.itemId)]) {
    //         props[tostring(v.itemId)] = v.getNum()
    //     }
    // }
    // for (var i = 1, v = UserManager.getInstance().timeProps[1]; v; i++ , v = UserManager.getInstance().timeProps[i]) {
    //     if (props[tostring(v.itemId)]) {
    //         props[tostring(v.itemId)] = v.num
    //     }
    // }
    // for (var k in props) {
    //     var v = props[k]
    //     params["item_id_" + k] = v
    // }
    // 记录道具存量
    for (var i = 1, v = UserManager.getInstance().props[1]; v; i++ , v = UserManager.getInstance().props[i]) {
        if (DATA_9_ITEMIDS.indexOf(tostring(v.itemId)) >= 0) {
            params[`item_${v.itemId}`] = v.getNum()
        }
    }
    // 记录历史累计付费额
    params.totalpay = UserManager.getInstance().getUserExtendRef().totalPayValue;
    DCAssist.dcAttackCommonData(params)
    var isBlock = 0;
    if (UserManager.getInstance().isAddStepBlock()){
        isBlock = 1;
    }
    params["extractmap"] = '{"share_promote":"'+(1-isBlock)+'"}';
    var stars = UserManager.getInstance().getStarChestInfo().starCount || 0
    dc.dcUserStatus_9(DCAssist.isNewUser && true || false, 0, tonumber(UserManager.getInstance().getUserRef().getCoin()), tonumber(UserManager.getInstance().getUserRef().getCash()), tonumber(UserManager.getInstance().getUserRef().getTopLevelId()), 0, tonumber(UserManager.getInstance().getUserRef().getEnergy()), 0, FriendManager.getInstance().getFriendCount(), FriendManager.getInstance().getActiveFriendCount(), 0, 0, tonumber(UserManager.getInstance().getUserRef().getTopLevelId()), tonumber(UserManager.getInstance().getUserRef().getTopLevelId()), DCAssist.paramsUtil(params), stars, true)
}
DCAssist.dcForNewUser = function () {
    var params = table()
    params.equipment = he.MetaInfo.getInstance().isJailbreak() && "crack" || "nocrack"
    params.networktype = he.MetaInfo.getInstance().getNetworkInfo() || 0
    params.carrier = he.MetaInfo.getInstance().getNetOperatorName() || ""
    params.install_key = he.MetaInfo.getInstance().getInstallKey() || ""
    params.idfa = __IOS && AppController.getAdvertisingIdentifier() || ""
    params.serial_number = he.MetaInfo.getInstance().getDeviceSerialNumber()
    params.android_id = he.MetaInfo.getInstance().getUdid()
    params.google_aid = ""
    params.md5 = ResourceLoader.getCurVersion()
    params.imei = he.MetaInfo.getInstance().getImei()
    params.imsi = he.MetaInfo.getInstance().getImsi()
    params.sns_id = DCAssist.getSNS_ID()
    params.login_channel = DCAssist.getLastLoginName()
    var recommendData = Localhost.getInstance().getRecommendData()
    if (recommendData) {
        params.have_animal = 1
        params.animal_uid = recommendData.uid || 0
    } else {
        params.have_animal = 0
        params.animal_uid = 0
    }
    console.log("[ad] wechat __CHANNEL_ID=" + tostring(_G.__CHANNEL_ID))
    if (_G.__CHANNEL_ID && _G.__CHANNEL_ID != ""){
        params.channel_id = _G.__CHANNEL_ID
    }
    DCAssist.dcAttackCommonData(params)
    dc.dcNewUser_1(DCAssist.paramsUtil(params))
    Localhost.getInstance().setIsNewUserDC()
}
DCAssist.dcForActiveUser = function () {
}
DCAssist.tryDC4EveryDayForeGround = function (sceneName) {
    var time_lastlogin = tonumber(Localhost.getLastLoginTime())
    var lastDate = os.date("*t", time_lastlogin)
    var currentDate = os.date("*t", tonumber(Localhost.timeInSec()))
    he_log_info(time_lastlogin)
    he_log_info("lastLogin:" + table.tostring(lastDate))
    he_log_info("currLogin:" + table.tostring(currentDate))
    if (lastDate.year === currentDate.year && lastDate.month === currentDate.month && lastDate.day === currentDate.day) {
        return
    }
    var params = table()
    params.equipment = he.MetaInfo.getInstance().isJailbreak() && "crack" || "nocrack"
    params.networktype = he.MetaInfo.getInstance().getNetworkInfo() || 0
    params.carrier = he.MetaInfo.getInstance().getNetOperatorName() || ""
    params.install_key = he.MetaInfo.getInstance().getInstallKey() || ""
    params.idfa = __IOS && AppController.getAdvertisingIdentifier() || ""
    params.serial_number = he.MetaInfo.getInstance().getDeviceSerialNumber()
    params.android_id = he.MetaInfo.getInstance().getUdid()
    params.google_aid = ""
    params.md5 = ResourceLoader.getCurVersion()
    params.imei = he.MetaInfo.getInstance().getImei()
    params.imsi = he.MetaInfo.getInstance().getImsi()
    params.sns_id = DCAssist.getSNS_ID()
    params.login_channel = DCAssist.getLastLoginName()
    var current_stage = null
    var session = null
    if (DCAssist.isInGaming) {
        current_stage = DCAssist.dcForStartGameParams.current_stage
        if (!sceneName) {
            sceneName = DCAssist.dcForStartGameParams.current_system
        }
        session = DCAssist.dcForStartGameParams.session
    }
    console.log("[ad] wechat __CHANNEL_ID=" + tostring(_G.__CHANNEL_ID))
    if (_G.__CHANNEL_ID && _G.__CHANNEL_ID != ""){
        params.channel_id = _G.__CHANNEL_ID
    }
    DCAssist.dcAttackCommonData(params, current_stage, sceneName, session)
    he_log_info("??????????????DCAssist.tryDC4EveryDayForeGround:dc:dcActiveUser_2")
    dc.dcActiveUser_2(tonumber(UserManager.getInstance().getUserRef().getTopLevelId()), DCAssist.paramsUtil(params))
    // pcall(function () {
    //     DCAssist.dc4UploadUserLocation()
    // })
}
DCAssist.cacheTransferDataOnPreload = function (data) {
    cc.log("========================DCAssist.cacheTransferDataOnPreload==========================")
    cc.log(table.tostring(data))
    DCAssist.transferDataOnPreload = table.clone(data)
}
DCAssist.cacheConnectDataOnPreload = function (data) {
    cc.log("========================DCAssist.cacheConnectDataOnPreload==========================")
    cc.log(table.tostring(data))
    DCAssist.connectDataOnPreload = table.clone(data)
}
DCAssist.cacheUIDOnPreload = function () {
    cc.log("========================DCAssist.cacheUIDOnPreload==========================")
    var uid = UserManager.getInstance().uid
    var sessionKey = UserManager.getInstance().sessionKey
    cc.log("uid:" + uid)
    cc.log("sessionKey:" + sessionKey)
    DCAssist.uidOnPreload = uid
    DCAssist.sessionKeyOnPreload = sessionKey
}
DCAssist.tryDC4NewUser = function () {
    cc.log("========================DCAssist.tryDC4NewUser==========================")
    var uid = UserManager.getInstance().uid
    var sessionKey = UserManager.getInstance().sessionKey
    cc.log("uid:" + uid)
    cc.log("sessionKey:" + sessionKey)
    var lastLoginOauthID = LoginBuffer.getInstance().getOAuthType()
    cc.log("loginOauthID:" + lastLoginOauthID)
    var bool = false
    if (DCAssist.transferDataOnPreload && DCAssist.transferDataOnPreload.isNew) {
        bool = true
    }
    if (bool) {
        DCAssist.isNewUser = true
        DCAssist.dcForNewUser()
    }
    DCAssist.transferDataOnPreload = null
    DCAssist.connectDataOnPreload = null
}
DCAssist.tryDC4NewUserOnReonline = function () {
    cc.log("========================DCAssist.tryDC4NewUserOnReonline==========================")
    var uid = UserManager.getInstance().uid
    var sessionKey = UserManager.getInstance().sessionKey
    cc.log("uid:" + uid)
    cc.log("sessionKey:" + sessionKey)
    var lastLoginOauthID = LoginBuffer.getInstance().getOAuthType()
    cc.log("loginOauthID:" + lastLoginOauthID)
    if (DCAssist.transferDataOnPreload && DCAssist.transferDataOnPreload.isNew) {
        DCAssist.isNewUser = true
        DCAssist.dcForNewUser()
    }
    DCAssist.transferDataOnPreload = null
    DCAssist.connectDataOnPreload = null
}
DCAssist.dc4OpenModule = function (name) {
    var params = table()
    params.feature = name || ""
    DCAssist.dcAttackCommonData(params)
    DCAssist.dc4ClickIcon("user_click", "home_scence", params)
}
// 界面被打开
DCAssist.dc4OpenPanel = function (name) {
    var params = table()
    params.feature = name || ""
    DCAssist.dcAttackCommonData(params)
    DCAssist.userTrack("click_open", "home_scence", params)
    this.dc4PageShow(name)
}
// 界面被打开
DCAssist.dc4PageShow = function (model) {
    var params = table()
    DCAssist.dcAttackCommonData(params)
    DCAssist.userTrack("page_show", model, params)
}


DCAssist.dc4GetCurrency = function (propId, num, sceneName, dcData) {
    if (tonumber(propId) === ItemType.COIN || tonumber(propId) === ItemType.GOLD || tonumber(propId) === ItemType.NewChestRedpack) {
        var currency_name = ItemWorth.OTHER
        if (tonumber(propId) === ItemType.COIN) {
            currency_name = ItemWorth.GAME_COINS
        } else if (tonumber(propId) === ItemType.NewChestRedpack) {
            currency_name = ItemWorth.CASH
        } else {
            currency_name = ItemWorth.HAPPY_COINS
        }
        var modules = tostring(sceneName) || "0"
        // var category = dcData.category || "0"
        var category = dcData.category || modules //应要求统一category
        var sub_category = dcData.sub_category || "0"

        var itemId = tostring(propId) || "0"
        var itemName = "0"
        var cost = 0
        var num = num || 0
        var coin1 = tonumber(dcData.coin1) || 0
        var coin2 = tonumber(dcData.coin2) || 0
        var currency = tostring(currency_name) || "0"
        var level = UserManager.getInstance().getUserRef().getTopLevelId()
        var currentStage = 0
        if (DCAssist.isInGaming) {
            currentStage = tonumber(DCAssist.level) || 0
        }

        var highStage = tonumber(UserManager.getInstance().getUserRef().getTopLevelId()) || 0
        var stageMode = 0
        if (DCAssist.isInGaming) {
            stageMode = tonumber(LevelType.getLevelTypeByLevelId(DCAssist.level)) || 0
        }
        var params = table()
        params.sub_category = sub_category || "0"
        params.scence = sceneName || "0"
        params.item_worth = dcData && dcData.item_worth || "0"
        params.worth_num = dcData && dcData.worth_num || "0"
        params.item_total = UserManager.getInstance().getUserPropNumber(tonumber(itemId)) || 0
        params.currency = tostring(currency_name) || "0"
        params.num = num || 0
        params.coin1 = dcData.coin1 || 0
        params.coin2 = dcData.coin2 || 0
        params.trade_id = dcData && dcData.trade_id || "0"
        params.goods_id = dcData && dcData.goods_id || ""
        if (params.currency == ItemWorth.RMB){//为人民币  单位换分算为元
            coin1 = coin1/100;
            coin2 = coin2/100;
            cost = cost/100;
            params.coin1 = params.coin1/100;
            params.coin2 = params.coin2/100;
        }
        DCAssist.dcAttackCommonData(params, currentStage, DCAssist.dcConvert2CurrentSystem(params.scence))
        he_log_info("DCAssist.dc4GetCurrency=====================================")
        he_log_info(modules)
        he_log_info(category)
        he_log_info(itemId)
        he_log_info(itemName)
        he_log_info(cost)
        he_log_info(num)
        he_log_info(coin1)
        he_log_info(coin2)
        he_log_info(currency)
        he_log_info(level)
        he_log_info(currentStage)
        he_log_info(highStage)
        he_log_info(stageMode)
        he_log_info(table.tostring(DCAssist.paramsUtil(params)))
        
        let session = null;
        if (DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.session) {
            session = DCAssist.dcForStartGameParams.session;
        }
        params.system = isPlatformIOS()? "iOS" : "Android"
        dc.dcCoinGain_72(modules, category, itemId, itemName, cost, num, coin1, coin2, currency, level, currentStage, highStage, stageMode, session, DCAssist.paramsUtil(params))
    }
}
DCAssist.dc4UseCurrencyWin32 = function (goodsId, num, sceneName, cost, tradeId) {
    //新增人民币购买打点
    var dcData = table()
    dcData.currency = ItemWorth.RMB
    dcData.coin1 = 0
    dcData.coin2 = 0
    dcData.cost = cost
    dcData.revenueCost = cost //无法知道折扣价格显示原价
    dcData.trade_id = tradeId || "0"
    DCAssist.dc4UseCurrency(goodsId, num, sceneName || "", dcData)
}

let _sceneNameToCategory = null;
function getCurrencyCategoryByModuleName(moduleName) {
    if (!moduleName || typeof ModuleName !== "object")
        return "0"
    
    if (_sceneNameToCategory == null) {
        _sceneNameToCategory = {
            [ModuleName.MARK]: "mark",
            [ModuleName.STAGE_START]: "buy_front_item",
            [ModuleName.STAGE_GAME]: "buy_item",
            [ModuleName.ADD_FIVE]: "plus_five_moves",
            [ModuleName.ENERGY]: "fill_energy",
            [ModuleName.BUY_GAME_COINS]: "transfer_coins",
            [ModuleName.COIN_MATCH_ACTIVITY]: "battleForGold",
            [ModuleName.GOLD_MATCH_ACTIVITY]: "goldMode",
            [ModuleName.PVP_ACTIVITY]: "pvp",   // 旧pvp
            [ModuleName.PVP_TICKET]: "pvp"  // 新友谊赛买门票
        }
    }
    let category = _sceneNameToCategory[moduleName] || moduleName //这里如果没找到对应的category 就是自己本身
    return category || "0";

}
DCAssist.dc4UseCurrency = function (goodsId, num, sceneName, dcData) {
    var activityId = "0"
    var category = dcData.category || getCurrencyCategoryByModuleName(sceneName)
    var itemId = tostring(goodsId) || "0"
    var itemName = tostring(getText("goods.name.text" + goodsId)) || "0"
    var cost = tonumber(dcData.cost) || 0
    var revenueCost = tonumber(dcData.revenueCost) || 0
    var num = tonumber(num) || 1
    var coin1 = tonumber(dcData.coin1) || 0
    var coin2 = tonumber(dcData.coin2) || 0
    var currency = tostring(dcData.currency) || "0"
    var mainAccount = 0
    var secondAccount = 0
    var level = UserManager.getInstance().getUserRef().getTopLevelId()
    var currentStage = 0
    if (DCAssist.isInGaming) {
        currentStage = tonumber(DCAssist.level) || 0
    }
    var highStage = tonumber(UserManager.getInstance().getUserRef().getTopLevelId()) || 0
    var stageMode = 0
    if (DCAssist.isInGaming) {
        stageMode = tonumber(LevelType.getLevelTypeByLevelId(DCAssist.level)) || 0
    }
    var params = table()
    params.scence = sceneName || "0"
    params.currency = dcData.currency || "0"
    params.currency_num = dcData.currency_num || 0
    params.coin1 = dcData.coin1 || 0
    params.coin2 = dcData.coin2 || 0
    params.item_id = tostring(goodsId)
    params.item_name = getText("goods.name.text" + goodsId) || "0"
    params.num = tonumber(num || 1)
    params.trade_id = dcData.trade_id || "0"
    if (params.currency == ItemWorth.RMB){//为人民币  单位换分算为元
        coin1 = coin1/100;
        coin2 = coin2/100;
        cost = cost/100;
        revenueCost = revenueCost/100;
        params.coin1 = params.coin1/100;
        params.coin2 = params.coin2/100;

        if(goodsId && goodsId >= 6000000 && goodsId <= 7999999) {
            params.item_name = goodsId <= 7000000 ? `A特惠礼包${cost}元档` : `B特惠礼包${cost}元档`;
        }
    }
    DCAssist.dcAttackCommonData(params, currentStage, DCAssist.dcConvert2CurrentSystem(params.scence))
    he_log_info("DCAssist.dc4UseCurrency=====================================")
    he_log_info(activityId)
    he_log_info(category)
    he_log_info(itemId)
    he_log_info(itemName)
    he_log_info(cost)
    he_log_info(revenueCost)
    he_log_info(num)
    he_log_info(coin1)
    he_log_info(coin2)
    he_log_info(currency)
    he_log_info(mainAccount)
    he_log_info(secondAccount)
    he_log_info(level)
    he_log_info(currentStage)
    he_log_info(highStage)
    he_log_info(stageMode)
    he_log_info(table.tostring(DCAssist.paramsUtil(params)))
    
    let session = null;
    if (DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.session) {
        session = DCAssist.dcForStartGameParams.session;
    }
    params.system = isPlatformIOS()? "iOS" : "Android"
    dc.dcCoinConsume_71(activityId, category, itemId, itemName, cost, revenueCost, num, coin1, coin2, currency, mainAccount, secondAccount, level, currentStage, highStage, stageMode, session, DCAssist.paramsUtil(params))
}
// DCAssist.dc4IOSpay71 = function (goodsId, num) {
//     var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId) || GoodsMetaRef.create()
//     var currency = ItemWorth.RMB
//     var currency_num = (goodsMeta.getRmb() || 0) * num
//     var coin1 = 0
//     var coin2 = 0
//     var cost = goodsMeta.rmb || 0
//     var revenueCost = goodsMeta.discountRmb || 0
//     var dcData = table()
//     dcData.currency = currency
//     dcData.currency_num = currency_num
//     dcData.coin1 = coin1
//     dcData.coin2 = coin2
//     dcData.cost = cost
//     dcData.revenueCost = revenueCost
//     DCAssist.dc4UseCurrency(goodsId, num, ModuleName.SHOP, dcData)
// }
DCAssist.dc4GetThings = function (propId, num, sceneName, dcData) {
    //物品获得打点
    if (tonumber(propId) === ItemType.COIN || tonumber(propId) === ItemType.GOLD) { } else {
        // var category = dcData.category || "get_item"
        var sub_category = dcData && dcData.sub_category || "0"
        var itemId = tostring(propId) || "0"
        var itemName = tostring(GamePropNamesForDC.getPropName(propId)) || "0"
        var scence = tostring(sceneName) || "0"
        var category = dcData && dcData.category || scence //应要求统一category
        var num = tonumber(num) || 0
        var level = UserManager.getInstance().getUserRef().getTopLevelId()
        var currentStage = 0
        if (DCAssist.isInGaming) {
            currentStage = tonumber(DCAssist.level) || 0
        }
        var highStage = tonumber(UserManager.getInstance().getUserRef().getTopLevelId()) || 0
        var stageMode = 0
        if (DCAssist.isInGaming) {
            stageMode = tonumber(LevelType.getLevelTypeByLevelId(DCAssist.level)) || 0
        }
        var params = table()
        params.sub_category = sub_category || "0"
        params.category = category
        params.scence = sceneName || "0"
        params.item_id = tostring(propId)
        params.item_name = GamePropNamesForDC.getPropName(propId)
        params.num = tonumber(num)
        params.item_worth = dcData && dcData.item_worth || "0"
        params.worth_num = dcData && dcData.worth_num || "0"
        params.item_total = UserManager.getInstance().getUserPropNumber(tonumber(itemId)) || 0
        params.trade_id = dcData && dcData.trade_id || "0"
        params.goods_id = dcData && dcData.goods_id || ""
        params.item1 = dcData && dcData.item1 || 0
        params.item2 = dcData && dcData.item2 || 0
        // 广告和分享的情况下 特殊处理 不会走前置道具的区分逻辑
        if (ItemType.isPreProp(propId) &&  params.category != "ad" && params.category != "share") {
            let propMeta = MetaManager.getInstance().getPropMeta(propId)
            if (propMeta.propMode === 9) {
                // 限时无限次道具
                params.sub_category = 1
            } else if (propMeta.expireTime > 0) {
                // 限时限次道具
                params.sub_category = 0
            } else {
                // 永久道具
                params.sub_category = 2
            }
        }
        if (UserPropData.isInfinitePreProp(propId)){// 限时无限次道具
            let propMeta = MetaManager.getInstance().getPropMeta(propId)
            params.sub_category = 3
            params.goods_id = UserPropData.getInfiniteMetaPreProp(propId)[1]
            params.item_total = params.num * tonumber(propMeta.expireTime)
            params.item_name = propMeta.propName
        }
        DCAssist.dcAttackCommonData(params, currentStage, DCAssist.dcConvert2CurrentSystem(params.scence))
        he_log_info("DCAssist.dc4GetThings===============123======================")
        he_log_info(category)
        he_log_info(itemId)
        he_log_info(itemName)
        he_log_info(scence)
        he_log_info(num)
        he_log_info(level)
        he_log_info(currentStage)
        he_log_info(highStage)
        he_log_info(stageMode)
        he_log_info(table.tostring(DCAssist.paramsUtil(params)))
        let session = null;
        if (DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.session) {
            session = DCAssist.dcForStartGameParams.session;
        }
        params.system = isPlatformIOS()? "iOS" : "Android"
        dc.dcItemGain_102(category, itemId, itemName, scence, num, level, currentStage, highStage, stageMode, session, DCAssist.paramsUtil(params))
    }
}

//energyParam 开始自动使用精力瓶用
DCAssist.dc4UseThings = function (itemList, sceneName, energyParam, itemCountBefore, session_new) {
    for (var i = 1, v = itemList[1]; v; i++ , v = itemList[i]) {
        if (tonumber(v.itemId) === ItemType.COIN || tonumber(v.itemId) === ItemType.GOLD) { } else {
            var category = "item_use"
            var itemId = tostring(v.itemId) || "0"
            var itemName = tostring(GamePropNamesForDC.getPropName(v.itemId)) || "0"
            var use = "0"
            var num = tonumber(v.num) || 0
            var level = UserManager.getInstance().getUserRef().getTopLevelId()
            var currentStage = 0
            let currentStep = 0
            if (DCAssist.isInGaming) {
                currentStage = tonumber(DCAssist.level) || 0
                let gameLogic = DCAssist.gameLogic
                if (gameLogic && gameLogic.getChildMapLevel()) {
                    // currentStage = tonumber(gameLogic.getChildMapLevel()) || 0
                    currentStep = gameLogic.getTheCurMoves()
                }
            }else if (energyParam){
                currentStage = energyParam.level || 0
            }
            var highStage = tonumber(UserManager.getInstance().getUserRef().getTopLevelId()) || 0
            var stageMode = 0
            if (DCAssist.isInGaming) {
                stageMode = tonumber(LevelType.getLevelTypeByLevelId(DCAssist.level)) || 0
            }else if (energyParam){
                stageMode = energyParam.stageMode || 0
            }
            var params = table()
            params.category = "item_use"
            params.scence = sceneName || "0"
            params.category =  params.scence //应要求统一category
            params.item_id = tostring(v.itemId) || 0
            params.item_name = GamePropNamesForDC.getPropName(v.itemId)
            params.num = tonumber(v.num) || 0
            params.remain = UserManager.getInstance().getUserPropNumber(tonumber(v.itemId)) || 0
            params.current_buy = 1
            if (DCAssist.isInGaming) {
                params.current_buy = DCAssist.propsBuyList[tostring(v.itemId)] && DCAssist.propsBuyList[tostring(v.itemId)] > 0 && 0 || 1
                params.step = currentStep
                params.session = DCAssist.playLevelSession
            }
            if (ItemType.isPreProp(v.itemId)) {
                let propMeta = MetaManager.getInstance().getPropMeta(v.itemId)
                if (propMeta.propMode === 9) {
                    // 限时无限次道具
                    params.sub_category = 1
                } else if (UserPropData.isInfinitePreProp(v.itemId)){
                    // 限时无限次道具
                    params.sub_category = 3
                    itemName = propMeta.propName
                } else if (propMeta.expireTime > 0) {
                    // 限时限次道具
                    params.sub_category = 0
                } else {
                    // 永久道具
                    params.sub_category = 2
                }
            }
            DCAssist.dcAttackCommonData(params, currentStage, DCAssist.dcConvert2CurrentSystem(params.scence))
            he_log_info("DCAssist.dc4UseThings=====================================")
            he_log_info(category)
            he_log_info(itemId)
            he_log_info(itemName)
            he_log_info(use)
            he_log_info(num)
            he_log_info(level)
            he_log_info(currentStage)
            he_log_info(highStage)
            he_log_info(stageMode)
            he_log_info(table.tostring(DCAssist.paramsUtil(params)))
            let session = null;
            if (DCAssist.dcForStartGameParams && DCAssist.dcForStartGameParams.session) {
                session = DCAssist.dcForStartGameParams.session;
            }
            params.item1 = itemCountBefore[itemId] || 0;
            params.item2 = params.remain;
            params.system = isPlatformIOS()? "iOS" : "Android"
            if (session_new) params.session = session_new
            dc.dcItemUse_103(category, itemId, itemName, use, num, level, currentStage, highStage, tostring(stageMode), session, DCAssist.paramsUtil(params))
        }
    }
}
DCAssist.dc4InfiProp = function (level, item_id, use_num) {
    let params = table()
    params.level = level
    params.item_id = item_id
    params.use_num = use_num
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("limitless_use", "use", DCAssist.paramsUtil(params))
}
DCAssist.dc4EnergyPropStartGame = function (itemID, use, num) {
    let params = {
        t1: 3
    }
    if (itemID === GamePropsType.kEnergy1) {
        params.t1 = 4
    }
    let sub = "G_trigger_energy"
    if (use) {
        params.t2 = num
        sub = "G_use_trigger_energy"
    }
    dc.dcUserTrack_101("stage", sub, DCAssist.paramsUtil(params))
}
DCAssist.dc4StarNew = function (predata, data, current_stage, session) {
    if (predata[1] > data[1]) {
        var newFinishStars = table()
        for (var k in predata[2]) {
            var v = predata[2][k]
            if (!data[2][k]) {
                newFinishStars[tostring(k)] = tostring(k)
            }
        }
        for (var k in newFinishStars) {
            var v = newFinishStars[k]
            var params = table()
            params.constellation_num = k
            var current_system = ""
            if (type(current_stage) === "number") {
                current_system = LevelType.getLevelTypeByLevelId(current_stage)
                if (current_system === GameLevelType.kMainLevel) {
                    current_system = "main_stage"
                } else if (current_system === GameLevelType.kHiddenLevel) {
                    current_system = "branch_stage"
                } else {
                    current_system = "home_scence"
                }
            }
            DCAssist.dcAttackCommonData(params, current_stage, current_system, session)
            dc.dcUserTrack_101("constellation", "finish", DCAssist.paramsUtil(params))
        }
    }
}
DCAssist.dc4RewardNew = function (predata, data, current_stage, session) {
    var bool = false
    if (type(predata[3]) === "number" && type(predata[4]) === "table") {
        if (!data[3]) {
            bool = true
        } else if (type(data[3]) === "number") {
            if (predata[3] < data[3]) {
                bool = true
            } else if (predata[3] === data[3]) {
                if (type(data[4]) === "table" && predata[4].isGetable === false && data[4].isGetable) {
                    bool = true
                }
            }
        }
    }
    if (bool) {
        var params = table()
        params.reward_num = predata[3]
        var current_system = ""
        if (type(current_stage) === "number") {
            current_system = LevelType.getLevelTypeByLevelId(current_stage)
            if (current_system === GameLevelType.kMainLevel) {
                current_system = "main_stage"
            } else if (current_system === GameLevelType.kHiddenLevel) {
                current_system = "branch_stage"
            } else {
                current_system = "home_scence"
            }
        }
        DCAssist.dcAttackCommonData(params, current_stage, current_system, session)
        dc.dcUserTrack_101("star_reward", "finish", DCAssist.paramsUtil(params))
    }
}
DCAssist.dc4GetStart = function (id) {}
DCAssist.dc4GetReward = function (id) {}
DCAssist.dc4AutoMarkOnDay = function (num, type, newMarkReward) {
    var raw_rewards = MetaManager.getInstance().getMarkByNum(num)
    if (type) {
        if (type == "old") {
            if (raw_rewards) {
                raw_rewards = raw_rewards.raw_rewards
            } else {
                raw_rewards = ""
            }
        } else if (type == "new") {
            if (newMarkReward) {
                var rewards = ""
                var length = $len(newMarkReward)
                for (var i = 1; i <= length; i++) {
                    if (i > 1) {
                        rewards += ","
                    }
                    rewards += newMarkReward[i].itemId.toString() + ":" + newMarkReward[i].num.toString()
                }
                raw_rewards = rewards
            } else {
                raw_rewards = ""
            }
        } else {
            cc.log("打点type异常")
        }
    }
    
    var params = table()
    params.num = num
    params.type = type
    params.reward = raw_rewards
    params.reward = string.gsub(params.reward, ":", ".")
    params.reward = string.gsub(params.reward, ",", "_")
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("mark", "success", DCAssist.paramsUtil(params))
}
//废弃
DCAssist.dc4MarkRefreshCircle = function () { }
DCAssist.dc4MarkAppendMark = function (total_num, type) {
    var params = table()
    params.total_num = total_num
    params.type = type
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("mark", "supplement", DCAssist.paramsUtil(params))
}
/**
 * 新版签到看广告补签
 */
DCAssist.dc4MarkAdAppendMark = function (total_num) {
    var params = table()
    params.total_num = total_num
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("mark", "supplement_ad", DCAssist.paramsUtil(params))
}
//废弃
DCAssist.dc4MarkTapGift = function () { }
DCAssist.dc4SpringGiftOpen = function () {
    var params = table()
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("spring_gift", " icon", DCAssist.paramsUtil(params))
}
DCAssist.dc4SpringGiftForceOpen = function () {
    var params = table()
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("spring_gift", "pop_up", DCAssist.paramsUtil(params))
}
DCAssist.dc4ShakeGetReward = function (num, reward, game_coin, shake_time) {
    var params = table()
    params.num = num
    params.reward = reward
    params.game_coin = game_coin
    params.shake_time = shake_time
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("shake", "get_reward", DCAssist.paramsUtil(params))
}
DCAssist.dc4ShakeGetTotalReward = function (reward) {
    var params = table()
    params.reward = reward
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("shake", "get_total_reward", DCAssist.paramsUtil(params))
}
DCAssist.dc4ShakeGetResult = function (num, shake_time) {
    var params = table()
    params.num = num
    params.shake_time = shake_time
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("shake", "get_result", DCAssist.paramsUtil(params))
}
DCAssist.dc4ReShake = function (cost, num, shake_time) {
    var params = table()
    params.cost = cost
    params.num = num
    params.shake_time = shake_time
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("shake", "shake_again", DCAssist.paramsUtil(params))
}
DCAssist.dc4ShakeResetByCash = function (cost, remaining_time) {
    var params = table()
    params.cost = cost
    params.remaining_time = remaining_time
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("shake", "buy_cd", DCAssist.paramsUtil(params))
}
DCAssist.dc4SharePopup = function (dcData) {
    dcData = dcData || table()
    var params = table()
    params.detail = dcData.name
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("share", "popup", DCAssist.paramsUtil(params))
}
DCAssist.dc4TapPassLevelToShare = function (current_stage) {
    var params = table()
    params.current_stage = current_stage
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("share", "click_pass", DCAssist.paramsUtil(params))
}
DCAssist.dc4TapStarGroupToShare = function (constellation_num) {}
DCAssist.dc4SharedStartOnForceOpen = function (dcData, channel1, channel2) {
    dcData = dcData || table()
    var params = table()
    params.detail = dcData.name
    params.channel1 = channel1
    params.channel2 = channel2
    params.package = PlatformConfig.getForkSrc()
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("share", "send", DCAssist.paramsUtil(params))
}
DCAssist.dc4SharedSuccess = function (dcData, channel1, channel2) {
    dcData = dcData || table()
    var params = table()
    params.detail = dcData.name
    params.channel1 = channel1
    params.channel2 = channel2
    params.package = PlatformConfig.getForkSrc()
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("share", "success", DCAssist.paramsUtil(params))
}
DCAssist.dc4LoveXiaoxiaoleOpen = function () {
    var params = table()
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("share", "click_love", DCAssist.paramsUtil(params))
}
DCAssist.dc4FriendGift = function (reward, num, method) {
    var params = table()
    params.reward = reward
    params.num = num
    params.method = method
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("freegift", "success", DCAssist.paramsUtil(params))
}
DCAssist.dc4RedBag = function (num) {
    var params = table()
    params.num = num
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("freegift", "red", DCAssist.paramsUtil(params))
}
DCAssist.dc4GetInviteReward = function (reward_num, reward, times) {
    var params = table()
    params.reward_num = reward_num
    params.reward = reward
    params.times = times
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("invite", "get_reward", DCAssist.paramsUtil(params))
}
DCAssist.dc4GetCoinDozerInviteReward = function (reward_num, reward) {}
DCAssist.dc4AddFriend = function (scence) {
    var params = table()
    params.scence = scence
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("friends", "apply", DCAssist.paramsUtil(params))
}
DCAssist.dc4GetEveryDayTaskReward = function (num) {
    var params = table()
    params.num = num
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("new_user_task", "daily_reward", DCAssist.paramsUtil(params))
}
DCAssist.dc4GetTotalGiftBoxReward = function (num) {
    var params = table()
    params.num = num
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("new_user_task", "total_reward", DCAssist.paramsUtil(params))
}
DCAssist.dc4HeadFrame = function (category, subCategory, frameId) {
    var params = {
        frameId: frameId
    }
    dc.dcUserTrack_101(category, subCategory, DCAssist.paramsUtil(params))
}
DCAssist.dc4DynamicUpdate = function (oldVersion, status, errCode, newVersion) {}
DCAssist.userTrack = function (category, subCategory, params) {
    params = params || table()
    category = category || "clover"
    subCategory = subCategory || ""
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101(category, subCategory, DCAssist.paramsUtil(params))
}
var CHANNEL_ID_FROM_BI = "he201612231049046769"
DCAssist.dc4Exposure = function () {
    var params = table()
    params.channel_id = CHANNEL_ID_FROM_BI
    params.user_id = UserManager.getInstance().uid || ""
    params.android_id = __ANDROID && he.MetaInfo.getInstance().getUdid() || ""
    params.idfa = __IOS && AppController.getAdvertisingIdentifier() || ""
    params.time = Localhost.time()
    DCAssist.dcAttackCommonData(params)
    dc.dcCustom(214, DCAssist.paramsUtil(params))
}
//13号点，映射为213
DCAssist.dc4GoXiaoxiaole = function () {
    var params = table()
    params.channel_id = CHANNEL_ID_FROM_BI
    params.user_id = UserManager.getInstance().uid || ""
    params.android_id = __ANDROID && he.MetaInfo.getInstance().getUdid() || ""
    params.idfa = __IOS && AppController.getAdvertisingIdentifier() || ""
    params.time = Localhost.time()
    DCAssist.dcAttackCommonData(params)
    dc.dcCustom(213, DCAssist.paramsUtil(params))
}
// DCAssist.dc4AndroidUpdateBigPackPop = function (version) {
//     if (__ANDROID) {
//         var params = table()
//         params.version = version || ""
//         dc.dcUserTrack_101("android_update", "popup", DCAssist.paramsUtil(params))
//     }
// }
// DCAssist.dc4AndroidUpdateBigPackComplete = function (version) {
//     if (__ANDROID) {
//         var params = table()
//         params.version = version || ""
//         dc.dcUserTrack_101("android_update", "download", DCAssist.paramsUtil(params))
//     }
// }
DCAssist.dc4CouponReward = function (gift, cdkey) {
    var params = table()
    params.gift = gift || ""
    params.cdkey_num = cdkey || ""
    dc.dcUserTrack_101("cdkey", "get_gift", DCAssist.paramsUtil(params))
}
function convertIngameName(name) {
    if (string.lower(tostring(name)) === "ingame") {
        var operator = GameProxy.getInstance().getOperator()
        if (operator === TelecomOperators.CHINA_MOBILE) {
            // WARN: maybe multi result
            return string.lower(PaymentNames[Payments.CHINA_MOBILE])
        } else if (operator === TelecomOperators.CHINA_UNICOM) {
            // WARN: maybe multi result
            return string.lower(PaymentNames[Payments.CHINA_UNICOM])
        } else if (operator === TelecomOperators.CHINA_TELECOM) {
            // WARN: maybe multi result
            return string.lower(PaymentNames[Payments.CHINA_TELECOM])
        }
    } else if (string.lower(tostring(name)) === string.lower(tostring(PaymentNames[Payments.WO3PAY]))) {
        var operator = GameProxy.getInstance().getOperator()
        if (operator === TelecomOperators.CHINA_MOBILE) {
            return string.lower(tostring(PaymentNames[Payments.WO3PAY])) + "_" + string.lower(PaymentNames[Payments.CHINA_MOBILE])
        } else if (operator === TelecomOperators.CHINA_UNICOM) {
            return string.lower(tostring(PaymentNames[Payments.WO3PAY])) + "_" + string.lower(PaymentNames[Payments.CHINA_UNICOM])
        } else if (operator === TelecomOperators.CHINA_TELECOM) {
            return string.lower(tostring(PaymentNames[Payments.WO3PAY])) + "_" + string.lower(PaymentNames[Payments.CHINA_TELECOM])
        }
    }
    return name
}
DCAssist.dc4AndroidPayPopPanel = function (goodsId, num) {
    if (!__ANDROID) {
        return
    }
    var params = table()
    params.goods_id = goodsId
    params.goods_num = num
    var supportPayTable = GameProxy.getInstance().getPaymentDicission()
    params.type_default = ""
    for (var i = 1, v = (supportPayTable.default || table())[1]; v; i++ , v = (supportPayTable.default || table())[i]) {
        params.type_default = params.type_default + "_" + convertIngameName(tostring(v))
    }
    if (params.type_default === "") {
        params.type_default = "null"
    }
    params.type_list = ""
    for (var i = 1, v = (supportPayTable.all || table())[1]; v; i++ , v = (supportPayTable.all || table())[i]) {
        params.type_list = params.type_list + "_" + convertIngameName(tostring(v))
    }
    if (params.type_list === "") {
        params.type_list = "null"
    }
    params.pop_num = 0
    var scene = cc.Director.getInstance().getRunningScene()
    if (scene && type(scene.name) === "string") {
        var paySceneNameCache = CacheManager.getInstance().paySceneNameCache
        if (!paySceneNameCache[scene.name]) {
            paySceneNameCache[scene.name] = 0
        }
        paySceneNameCache[scene.name] = paySceneNameCache[scene.name] + 1
        params.pop_num = paySceneNameCache[scene.name]
    }
    params.real_name = VerifiedManager.getInstance().getVerifiedMaintanceEnable()
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("payment", "panel", DCAssist.paramsUtil(params))
}
// DCAssist.dc4AndroidPayStart = function (goodsId, num, payType) {
//     if (!__ANDROID) {
//         return
//     }
//     var params = table()
//     params.pay_id = CacheManager.getInstance().getPaymentTradeID()
//     params.type_choose = convertIngameName(UserDealData.getPayTagByType(payType))
//     params.goods_id = goodsId
//     params.goods_num = num
//     var supportPayTable = GameProxy.getInstance().getPaymentDicission()
//     params.type_default = ""
//     for (var i = 1, v = (supportPayTable.default || table())[1]; v; i++ , v = (supportPayTable.default || table())[i]) {
//         params.type_default = params.type_default + "_" + convertIngameName(tostring(v))
//     }
//     if (params.type_default === "") {
//         params.type_default = "null"
//     }
//     params.province = Cookie.getInstance().read(CookieKey.kLocationProvince)
//     params.pop_num = 0
//     var scene = cc.Director.getInstance().getRunningScene()
//     if (scene && type(scene.name) === "string") {
//         var paySceneNameCache = CacheManager.getInstance().paySceneNameCache
//         if (!paySceneNameCache[scene.name]) {
//             paySceneNameCache[scene.name] = 0
//         }
//         params.pop_num = paySceneNameCache[scene.name]
//     }
//     params.real_name = VerifiedManager.getInstance().getVerifiedMaintanceEnable()
//     DCAssist.dcAttackCommonData(params)
//     dc.dcUserTrack_101("payment", "start", DCAssist.paramsUtil(params))
// }
// DCAssist.dc4AndroidPayEnd = function (goodsId, num, payType, result, error_code) {
//     if (!__ANDROID) {
//         return
//     }
//     var params = table()
//     params.pay_id = CacheManager.getInstance().getPaymentTradeID()
//     params.result = result
//     params.error_code = error_code
//     var supportPayTable = GameProxy.getInstance().getPaymentDicission()
//     params.type_default = ""
//     for (var i = 1, v = (supportPayTable.default || table())[1]; v; i++ , v = (supportPayTable.default || table())[i]) {
//         params.type_default = params.type_default + "_" + convertIngameName(tostring(v))
//     }
//     if (params.type_default === "") {
//         params.type_default = "null"
//     }
//     params.type_choose = convertIngameName(UserDealData.getPayTagByType(payType))
//     params.goods_id = goodsId
//     params.goods_num = num
//     params.price = 0
//     var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId) || GoodsMetaRef.create()
//     params.price = goodsMeta.getRmb() || 0
//     params.province = Cookie.getInstance().read(CookieKey.kLocationProvince)
//     params.pop_num = 0
//     var scene = cc.Director.getInstance().getRunningScene()
//     if (scene && type(scene.name) === "string") {
//         var paySceneNameCache = CacheManager.getInstance().paySceneNameCache
//         if (!paySceneNameCache[scene.name]) {
//             paySceneNameCache[scene.name] = 0
//         }
//         params.pop_num = paySceneNameCache[scene.name]
//     }
//     params.real_name = VerifiedManager.getInstance().getVerifiedMaintanceEnable()
//     DCAssist.dcAttackCommonData(params)
//     dc.dcUserTrack_101("payment", "end", DCAssist.paramsUtil(params))
// }
DCAssist.dc4InviteEstablish = function (from, fromUid) {
    var params = table()
    params.from = from
    params.from_uid = fromUid
    dc.dcUserTrack_101("invite", "establish", DCAssist.paramsUtil(params))
}
DCAssist.dc4LoginClick = function (channel, panel) {
    var params = table()
    params.channel = channel || ""
    params.panel = panel || ""
    if (Localhost.getLastLoginOauthIDActual()) {
        params.login_already = PlatformConfig.getPlatformAuthName(Localhost.getLastLoginOauthID())
    } else {
        params.login_already = "null"
    }
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("login", "click_button", DCAssist.paramsUtil(params))
}
DCAssist.dc4OtherLoginClick = function () {
    var params = table()
    if (Localhost.getLastLoginOauthIDActual()) {
        params.login_already = PlatformConfig.getPlatformAuthName(Localhost.getLastLoginOauthID())
    } else {
        params.login_already = "null"
    }
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("login", "click_other", DCAssist.paramsUtil(params))
}
DCAssist.dc4AutoLoginStart = function () {
    var params = table()
    params.channel = PlatformConfig.getPlatformAuthName(Localhost.getLastLoginOauthID())
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("login", "auto_start", DCAssist.paramsUtil(params))
}
DCAssist.dc4AutoLoginFinish = function () {
    var params = table()
    params.channel = PlatformConfig.getPlatformAuthName(Localhost.getLastLoginOauthID())
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("login", "auto_finish", DCAssist.paramsUtil(params))
}
DCAssist.dc4UploadUserLocation = function () {}
/*     @desc: 正交分组打点
    --@testId: 测试id
	--@testName: 测试名称
	--@groupId: 记录用户分组编号(1、2、3...)
	--@result: 记录用户当前是否实际被干预（满足策略条件），1是0否
    @return: nil
 */
DCAssist.dc4OrthGroup = function (testId, testName, groupId, result) {
    let params = table()
    DCAssist.dcAttackCommonData(params)
    params.test_id = testId
    params.test_name = testName
    params.num = groupId
    if (result) {
        params.type = 1
    } else {
        params.type = 0
    }
    dc.dcUserTrack_101("abtest", "test_group", DCAssist.paramsUtil(params))
}
// 线上输出DEBUG信息 还原无法复现的BUG现场
DCAssist.dcOnlineDebugInfo = function (method, params) {
    params = params || table()
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("debugInfo", tostring(method), DCAssist.paramsUtil(params))
}
DCAssist.dc4AppStoreVersionCheck = function () {
    if (!__IOS) {
        return
    }
    var params = table()
    params.version = AppController.getBundleShortVersion() || ""
    params.update_version = cc.UserDefault.getInstance().getStringForKey("clover_apple_short_ver_9", "") || ""
    dc.dcUserTrack_101("ios_update", "check", DCAssist.paramsUtil(params))
}
DCAssist.dc4AppStoreVersionPop = function (scene) {
    if (!__IOS) {
        return
    }
    var params = table()
    params.version = AppController.getBundleShortVersion() || ""
    params.update_version = cc.UserDefault.getInstance().getStringForKey("clover_apple_short_ver_9", "") || ""
    params.scene = scene
    dc.dcUserTrack_101("ios_update", "pop", DCAssist.paramsUtil(params))
}
DCAssist.dc4AppStoreVersionConfirm = function () {
    if (!__IOS) {
        return
    }
    var params = table()
    params.version = AppController.getBundleShortVersion() || ""
    params.update_version = cc.UserDefault.getInstance().getStringForKey("clover_apple_short_ver_9", "") || ""
    dc.dcUserTrack_101("ios_update", "confirm", DCAssist.paramsUtil(params))
}
DCAssist.dc4AppStoreVersionConfirmInGame = function () {
    if (!__IOS) {
        return
    }
    var params = table()
    params.version = AppController.getBundleShortVersion() || ""
    params.update_version = cc.UserDefault.getInstance().getStringForKey("clover_apple_short_ver_9", "") || ""
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("ios_update", "update", DCAssist.paramsUtil(params))
}
DCAssist.dcForActivity = function (game_type, game_name, category, sub_category, params) {
    params = params || table()
    params.game_name = game_name
    params.category = category
    params.sub_category = sub_category
    dc.dcCustom(109, DCAssist.paramsUtil(params))
}
DCAssist.dc4Verified = function (subCategory, scenceName, phone_num, err) {
    // body
    var params = table()
    params.scence = scenceName || ""
    params.login_channel = DCAssist.getLastLoginName()
    if (phone_num) {
        params.phone_num = he.HeMathUtils.base64Encode(phone_num, string.len(phone_num))
    }
    if (err) {
        params.error = err
    }
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("real_name", subCategory, DCAssist.paramsUtil(params))
}
DCAssist.dc4Task = function (subCategory, taskId, progress) {
    // body
    var params = table()
    if (taskId) {
        params.id = taskId
    }
    if (progress) {
        params.id = progress
    }
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("task", subCategory, DCAssist.paramsUtil(params))
}
DCAssist.dc4Share = function (subCategory) {
    // body
    var params = table()
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("share", subCategory, DCAssist.paramsUtil(params))
}
DCAssist.dcForEnergyShare = function (subCategory, params) {
    dc.dcUserTrack_101("stage", subCategory, DCAssist.paramsUtil(params || table()))
}
DCAssist.weekGameFetchBoxReward = function (chest_num, chest_reward) {}
DCAssist.weekGamePassChildLevel = function (stage_num, level, moves, targetNum, itemId, itemNum) {}
DCAssist.weekGameSkill = function (stage_num, skillNum) {}
DCAssist.composeLine = function (levelId, times, session) {
    // body
    let params = table()
    params.level = levelId
    params.compose_num = times
    params.session = session
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("compose_line", "compose", DCAssist.paramsUtil(params))
}
DCAssist.composeBomb = function (levelId, times, session) {
    // body
    let params = table()
    params.level = levelId
    params.compose_num = times
    params.session = session
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("compose_bomb", "compose", DCAssist.paramsUtil(params))
}
DCAssist.composeTian = function (levelId, times, session) {
    // body
    let params = table()
    params.level = levelId
    params.compose_num = times
    params.session = session
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("compose_tian", "compose", DCAssist.paramsUtil(params))
}
DCAssist.energy3Buff = function (category, subCategory) {
    let params = table()
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101(category, subCategory, DCAssist.paramsUtil(params))
}
DCAssist.prompPrompt = function (mainLogic, c, s_c) {
    let params = {
        level: mainLogic.level,
        mode: mainLogic.theGamePlayType,
        step: mainLogic.getTheCurMoves(),
        session: DCAssist.playLevelSession
    }
    dc.dcUserTrack_101(c, s_c, DCAssist.paramsUtil(params))
}
DCAssist.dc4IsUseSmallRes = function () {
    let isUseSmallRes = _G.__use_small_res
    let openid = META.user.openid
    let params = {
        isUseSmallRes: isUseSmallRes,
        openid : openid,
        is_new_device: META.is_new_device
    }
    dc.dcUserTrack_101("other", "n6xVersion", DCAssist.paramsUtil(params))
}
DCAssist.dc4ShareGroupOrSession = function (cat, sub, isGroup = false, data = {}) {
    data.isGroup = isGroup
    DCAssist.dc4ShareResult(cat, sub, data)
}
/**
 * 点击分享按钮时打点
 * @param cat 
 * @param sub 
 * @param data 
 */
DCAssist.dc4ShareSend = function (cat, sub, data = {}) {
    data.behavior = "send"
    DCAssist.dc4ClickShare(cat, sub, data)
}
// DCAssist.dc4ShareResult = function (cat, sub, data = {}) {
//     data.behavior = "result"
//     DCAssist.dc4ClickShare(cat, sub, data)
// }

/**
 * 点击播放广告按钮
 * @param cat 
 * @param sub 
 * @param data 
 */
DCAssist.dc4AdClick = function (cat, sub, data = {}) {
    data.ad_type = "click"
    DCAssist.userTrack(cat, sub, data)
}

/**
 * 广告播放完成
 * @param cat 
 * @param sub 
 * @param data 
 */
DCAssist.dc4AdFinish = function (cat, sub, data = {}) {
    data.ad_type = "finish"
    if (UserManager.getInstance().isHaveEquityMonthTicket()){
        cc.log("MonthTicket 权益卡生效  ")
        data.ad_type = "skip"
    }
    DCAssist.userTrack(cat, sub, data)
}


/**
 * 广告中途退出
 * @param cat 
 * @param sub 
 * @param data 
 */
DCAssist.dc4AdDropOut = function (cat, sub, data = {}) {
    data.ad_type = "dropout"
    DCAssist.userTrack(cat, sub, data)
}

/**
 * 广告中途退出New
 * @param cat 
 * @param sub 
 * @param data 
 */
DCAssist.dc4AdDropOutNew = function (cat, sub, data = {}) {
    data.ad_type = "ad_dropout"
    DCAssist.userTrack(cat, sub, data)
}

/**
 * 没有广告可看
 * @param cat 
 * @param sub 
 * @param data 
 */
DCAssist.dc4AdNoMore = function (cat, sub, data = {}) {
    data.ad_type = "noAds"
    DCAssist.userTrack(cat, sub, data)
}


/**
 * 点击icon
 * @param cat 
 * @param sub 
 * @param data 
 */
DCAssist.dc4ClickIcon = function (cat, sub, data = {}) {
    data.click_type = "icon"
    DCAssist.userTrack(cat, sub, data)
}

/**
 * 分享的category & subcategory 到 channel_id映射
* 数据来源：https://docs.google.com/spreadsheets/d/1C0ZFXrVnl_DmPm5mRoofF-Qp0az-kKBa5m6FkkoNxNI/edit#gid=908878554
* 转换脚本：tools/channel_id_trans.js
 */
let _channelIdMap = { 
//     timeMode:
//     { click_share_btn_success: 'he201911071842256190',
//       click_gethelp_btn_success: 'he201911071842256190',
//       click_share_success: 'he201911071842256190' },
//    battleForGold:
//     { click_askforhelp_success: 'he201911071842256190',
//       click_invFriends_btn_success: 'he201911071842256190',
//       click_share_btn_success: 'he201911071842256190' },
//    goldMode:
//     { click_askforhelp_success: 'he201911071842256190',
//       click_getHelp_btn_success: 'he201911071842256190',
//       click_share_btn_success: 'he201911071842256190' },

   gacha: { click_share: 'he201911071842256190' },
   plusFiveMoves: { click_share_btn_success: 'he201911071842263286' },
   share:
    { level_showoff_share_click: 'he201911071842263488',
      level_showoff_share_click_success: 'he201911071842263488',
      lack_of_happycoins: 'he201911071842300979' },
   island: { upgrade: 'he201911071842274247' },
   levelTip:
    { click_share_success: 'he201911071842280571',
      showoff_share_success: 'he201911071842280571' },
   PVP:
    { click_invite_friend_btn: 'he201911071842287403',
      click_invite_friend_btn_success: 'he201911071842287403',
      click_share_btn: 'he201911071842287403',
      click_share_btn_success: 'he201911071842287403' },
   redbag: { click_share_success: 'he201911071842291320' },
   starChest: { click_share_success: 'he201911071842300917' },
   rank: {
        click_invitefd_btn_success: 'he201911071842300979', 
       click_grouprank_btn_success: 'he201911071842300979' 
    },
   stage_start: { share_getcoins_send_success: 'he201911071842300979' },
   interactive: { card_send_success: ['he201911071848063747', 'he201911071848053905']},
   level_bonus: { share_success: 'he201911071848044752'},
   newrank_showoff: { share_success: 'he201911071842319249'},
   newrank_share: { share_success: 'he201911071842319249'},
   invitepack: { click_invitepack_btn_success: 'he201911071842323379'}
}

/**
 * 点击分享按钮
 */
DCAssist.dc4ClickShare = function (cat, sub, data = {}, extraData) {
    data.click_type = "share"

    // 分享添加share_id与channel_id字段
    if (cat && sub && _channelIdMap[cat] && _channelIdMap[cat][sub]) {
        let channel_id = _channelIdMap[cat][sub]
        if (typeof channel_id !== "string")
            channel_id = extraData? channel_id[extraData.channel_index]: channel_id[0];
        if (data.textId)
            data.share_id = data.textId;
    }

    if(__DEBUG) {
        if (!data || !data.textid) {
            console.error("！！！分享必须打textid字段！！！", JSON.stringify({
                cat,sub
            }))
        }
    }
    DCAssist.userTrack(cat, sub, data)
}

DCAssist.dc4User101 = function (cat, sub, data = {}) {
    dc.dcUserTrack_101(cat, sub, DCAssist.paramsUtil(data))
}
DCAssist.dc4LevelUserOp110 = function (level) {
    let sub = "preload"
    DCAssist.dc4LevelUserOp(level, sub)
}
DCAssist.dc4LevelUserOp120 = function (level) {
    let sub = "loaded"
    DCAssist.dc4LevelUserOp(level, sub)
}
DCAssist.dc4LevelUserOp130 = function (level) {
    let sub = "guide"
    DCAssist.dc4LevelUserOp(level, sub)
}
DCAssist.dc4LevelUserOp140 = function (level) {
    let sub = "first"
    DCAssist.dc4LevelUserOp(level, sub)
}
DCAssist.dc4LevelUserOp150 = function (level) {
    let sub = "finish"
    DCAssist.dc4LevelUserOp(level, sub)
}
DCAssist.dc4LevelUserOp160 = function (level) {
    let sub = "finish_before_endLevel"
    DCAssist.dc4LevelUserOp(level, sub)
}
DCAssist.dc4LevelUserOp170 = function (level) {
    let sub = "finish_send_request"
    DCAssist.dc4LevelUserOp(level, sub)
}
DCAssist.dc4LevelUserOp = function (level, sub) {

    if (typeof level !== "number" && level > 20) {
        return
    }
    let data = {
        is_new_user: kIsNewUser,
        levelId: level,
        interval: new Date().getTime() - (window.INIT_TIMESTAMP || new Date().getTime())
    }
    DCAssist.dc4User101("user_level_op", sub, data)
}
DCAssist.dc4UserGameSpeed = function () {
    let data = {
        num: GamePlayConfig_GameBoard_Speed[GameSpeedManager.getInstance().levelTypeSpeed[GameLevelType["kMainLevel"]]] 
    }
    DCAssist.dc4User101("wx_setting", "main_level_speed", data)
}
DCAssist.dc4UserPortrait = function (name, gender, country, province, city) {
    var dcData = {}
    dcData.name = b64Encode(name)
    dcData.gender = (gender || 0).toString()
    dcData.country = country || ""
    dcData.province = province || ""
    dcData.city = city || ""
    dc.dcUserPortrait_900(dcData)
}
/**
 * 显示Banner广告
 * @param type      面板名称
 * @param id        广告位ID
 */
DCAssist.dc4BannerAdShow = function (type, id) {
    let session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    let data = {
        type: type,
        id: id,
        session: session
    }
    DCAssist.dc4User101("banner_ad", "show", data)
    return session
}
DCAssist.dc4BannerAdClose = function (type, id, session) {
    let data = {
        type: type,
        id: id, 
        session: session
    }
    DCAssist.dc4User101("banner_ad", "close", data)
}

/**
 * 触发不安全图片下载信息
 */
DCAssist.dc4UnsafePic = function(extractmap) {
    dc.dc2UseractionUnknownCategory("picdownload", "", extractmap?{ extractmap: JSON.stringify(extractmap) }: null);
}

/**
 * 记录文件下载失败信息
 */
DCAssist.dc4SaveFileFailed = function(extractmap) {
    dc.dc2UseractionUnknownCategory("datadownload", "", extractmap?{ extractmap: JSON.stringify(extractmap) }: null);
}

// 获取ios支付category
DCAssist.getIosPayCategory = function() {
    let str = UserManager.getInstance().getIosPayType() == "mini" ? "ios_payment" : "ios_payment_custom"
    if (window.mini && mini.getPlatform() == MiniPlatform.tt && mini.getSystemInfoSync().platform == "ios") {
        str = "douyin_ios_payment"
    }
    return str
}

//添加购买buy 的click、finish、fail的额外字段
DCAssist.fillExtraParameters = function (dcCashData, dcData) {
    if (dcData && dcCashData) {
        //新增固定几个字段，防止dcCashData无效字段太多
        let arr = ["event_id", "fsp_algorithm_id", "fsp_event_id", "current_stage", "extractmap"];
        for (let i = 0; i < arr.length; i++) {
            const temp = arr[i];
            if (dcCashData.hasOwnProperty(temp)) {
                dcData[temp] = dcCashData[temp]
            }
        }
    }
}

DCAssist.dc4ShowCashGoodsSignle = function(scence, entry, goodsIds, paramSortable = false,new_session,extra) {
    let category = "cash_goods"
    let session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    if (new_session) session = new_session
    if (!paramSortable) {
        goodsIds = Array.from(goodsIds);
    }
    goodsIds.sort((a, b)=> a-b);
    //ios
    if (UserManager.getInstance().canIosToMiniPay()){
        category = DCAssist.getIosPayCategory()
    }
    let param = {
        goods_id: goodsIds.join("_"),
        scence,
        entry,
        session,
        current_stage : UserManager.getInstance().user.topLevelId
    }
    if (extra){
        for (const key in extra) {
            param[key] = extra[key]
        }
    }
    dc.dcCashGoods(category, "package_single_show", param);
    return session; // session用于串联流程，后续的click 和 finsih 行为需要使用同样的session
}
/**
 * 关末加步数界面的通行证以banner形式曝光时
 */
DCAssist.dc4ShowBattlePassBanner = function(entry, dcData){
    let category = "cash_goods"
    let session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    //ios
    if (UserManager.getInstance().canIosToMiniPay()){
        category = DCAssist.getIosPayCategory()
    }
    let param = {
        goods_id: BattlePassLogic.getInstance().getGoodsId(),
        scence: "battle_pass",
        session: session,
        entry: entry,
        event_id: DCAssist.playLevelSession
    }
    if(dcData) {
        for (const key in dcData) {
            param[key] = dcData[key]
        }
    }
    dc.dcCashGoods(category, "banner_show", param)
    return session
}
/**
 * 记录现金商品曝光
 */
DCAssist.dc4ShowCashGoods = function(scence, entry, goodsIds, paramSortable = false, new_session, extra) {
    let session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    if (new_session) session = new_session
    if (!paramSortable) {
        goodsIds = Array.from(goodsIds);
    }
    goodsIds.sort((a, b)=> a-b);

    let category = "cash_goods"
    //ios
    if (UserManager.getInstance().canIosToMiniPay()){
        category = DCAssist.getIosPayCategory()
    }
    let param = {
        goods_id: goodsIds.join("_"),
        scence,
        entry,
        session,
        current_stage : UserManager.getInstance().user.topLevelId
    }
    if (extra){
        for (const key in extra) {
            param[key] = extra[key]
        }
    }
    dc.dcCashGoods(category, "show", param);
    return session; // session用于串联流程，后续的click 和 finsih 行为需要使用同样的session
}

/**
 * 记录尝试购买现金商品
 */
DCAssist.dc4BuyCashGoods = function(session, scence, goodsId, entry, dcCashData) {
    let category = "cash_goods"
    //ios
    if (UserManager.getInstance().canIosToMiniPay()){
        category = DCAssist.getIosPayCategory()
    }
    let dcData = {
        goods_id: goodsId,
        scence,
        session,
        entry
    };
    //
    DCAssist.fillExtraParameters(dcCashData, dcData);
    dc.dcCashGoods(category, "click", dcData);
}
/**
 * 记录iosmini现金商品购买成功
 */
 DCAssist.dc4IosGetCashGoods = function(session, scence, goodsId, entry, price, order_id, dcCashData) {

    dc.dcCashGoods(DCAssist.getIosPayCategory(), "receive_good", {
        goods_id: goodsId,
        scence,
        session,
        entry,
        price,
        current_stage : UserManager.getInstance().user.topLevelId,
        order_id,
        event_id: dcCashData ? dcCashData.event_id : "",
    });
}
/**
 * 记录iosmini跳转购买失败
 */
 DCAssist.dc4IosGotoBuyCashGoodsFail = function(session, scence, goodsId, reason, entry) {
    dc.dcCashGoods(DCAssist.getIosPayCategory(), "jump_fail", {
        goods_id: goodsId,
        scence,
        session,
        reason,
        entry
    });
}
/**
 * 记录iosmini跳转客服成功
 */
DCAssist.dc4IosGotoBuyCashGoodsSuccess = function(session, scence, goodsId, order_id, reason, entry) {
    dc.dcCashGoods(DCAssist.getIosPayCategory(), "jump_success", {
        goods_id: goodsId,
        scence,
        session,
        order_id,
        reason,
        entry
    });
}
/**
 * 记录跳转客服第一次提示页面曝光时
 */
DCAssist.dc4ReminderShow = function(session) {
    dc.dcCashGoods(DCAssist.getIosPayCategory(), "reminder_show_1", {
        session
    });
}
/**
 * 记录现金商品购买成功
 */
DCAssist.dc4GetCashGoods = function(session, scence, goodsId, entry, price, order_id, dcCashData) {
    if (UserManager.getInstance().canIosToMiniPay()){
        return
    }
    let dcData = {
        goods_id: goodsId,
        scence,
        session,
        entry,
        price,
        order_id
    };
    //
    DCAssist.fillExtraParameters(dcCashData, dcData);
    dc.dcCashGoods("cash_goods", "finish", dcData);
}
/**
 * 记录现金商品购买失败
 */
DCAssist.dc4BuyCashGoodsFail = function(session, scence, goodsId, reason, order_id, entry, price, dcCashData) {
    if (UserManager.getInstance().canIosToMiniPay()){
        return
    }
    let dcData = {
        goods_id: goodsId,
        scence: scence,
        session:session,
        reason:reason,
        order_id:order_id,
        entry : entry,
        price : price
    };
    //
    DCAssist.fillExtraParameters(dcCashData, dcData);
    dc.dcCashGoods("cash_goods", "fail", dcData);
}

/**
 * 记录抖音iOS支付创建订单完成
 */
DCAssist.dc4TTIosCreateOrder = function(session, scence, goodsId, orderId) {
    dc.dcCashGoods(DCAssist.getIosPayCategory(), "create_order", {
        goods_id: goodsId,
        scence:scence,
        session:session,
        order_id:orderId
    });
}
/**
 * 记录抖音iOS支付成功，在查询订单结果成功处
 */
 DCAssist.dc4TTIosPayFinish = function(session, scence, goodsId, orderId, price, reason) {
    dc.dcCashGoods(DCAssist.getIosPayCategory(), "finish", {
        goods_id: goodsId,
        order_id:orderId,
        scence:scence,
        session:session,
        price:price,
        reason:reason
    });
}
/**
 * 记录抖音iOS支付失败，在查询订单结果失败处
 */
 DCAssist.dc4TTIosPayFail = function(session, goodsId, orderId, reason) {
    dc.dcCashGoods(DCAssist.getIosPayCategory(), "fail", {
        goods_id: goodsId,
        order_id:orderId,
        session:session,
        reason:reason
    });
}
/**
 * 分享按键曝光
 * @param {*} mainScene 主场景
 * @param {*} dcShareError 场景显示了分享按钮，但是此时分享按钮不能发起分享的错误码
 */
DCAssist.dc4ShareShow = function(mainScene, dcShareError = DCShareShowError.None, extractmap = null) {
    let param = {
        main_scene: mainScene,
        channel_id: SHARE_CHANNEL_ID,
        share_state: (dcShareError && dcShareError != DCShareShowError.None)? "0": "1",
        error_code: (dcShareError && dcShareError != DCShareShowError.None)? dcShareError: DCShareShowError.None
    }
    if (extractmap) {
        param.extractmap = JSON.stringify(extractmap);
    }

    dc.dcShareAction("share", "share_button_expose", param);
}

DCAssist.dc4ShareClick = function(mainScene, textId, extractmap = null) {
    if (__DEBUG) {
        // textId漏掉会导致裂变统计无法正常处理，debug模式下强制检查一下
        cc.assert(textId, "DCAssist.dc4ShareClick|textId must be non-null. mainScene=" + mainScene);
    }
    let param = {
        main_scene: mainScene,
        channel_id: SHARE_CHANNEL_ID,
        text_id: textId
    }
    if (extractmap) {
        param.extractmap = JSON.stringify(extractmap);
    }
    dc.dcShareAction("share", "share_button_click", param);
}

/**
 * 分享发送成功
 * @param {*} mainScene 主场景
 * @param {*} textId  分享组文本id
 * @param {*} otherData 其它需要打的内容
 */
DCAssist.dc4ShareSent = function(mainScene, textId, extractmap = null) {
    if (__DEBUG) {
        // textId漏掉会导致裂变统计无法正常处理，debug模式下强制检查一下
        cc.assert(textId, "DCAssist.dc4ShareSent|textId must be non-null. mainScene=" + mainScene);
    }
    let param = {
        main_scene: mainScene,
        channel_id: SHARE_CHANNEL_ID,
        text_id: textId
    }
    if (extractmap) {
        param.extractmap = JSON.stringify(extractmap);
    }
    dc.dcShareAction("share", "share_send_success", param);
}

/**
 * 从分享启动游戏
 * @param {*} mainScene 
 * @param {*} textId 
 * @param {*} inviterId 
 */
DCAssist.dc4ShareLaunch = function(mainScene, textId, inviterId, extractmap = null) {
    if (__DEBUG) {
        // textId漏掉会导致裂变统计无法正常处理，debug模式下强制检查一下
        cc.assert(textId, "DCAssist.dc4ShareEntry|textId must be non-null. mainScene=" + mainScene);
    }
    let param = {
        main_scene: mainScene,
        channel_id: SHARE_CHANNEL_ID,
        text_id: textId,
        inviter_id: inviterId,
        is_new: _G.kIsNewUser? "1": "0",
        is_new_device: _G.kIsNewInstall? "1": "0"
    }
    if (extractmap) {
        param.extractmap = JSON.stringify(extractmap);
    }
    dc.dcShareAction("share", "share_enter", param);
}

/**
 * 定向分享发送成功
 * @param {*} mainScene 主场景
 * @param {*} textId  分享组文本id  定向分享没有办法保证一定有textid可以获取
 * @param {*} extractmap 其它需要打的内容
 */
DCAssist.dc4SMFShareSent = function(mainScene, textId, extractmap = null) {
    let param = {
        main_scene: mainScene,
        channel_id: SHARE_CHANNEL_ID,
        text_id: textId
    }
    if (extractmap) {
        param.extractmap = JSON.stringify(extractmap)
    }
    dc.dcShareAction("share_messege_friend", "share_send_success", param);
}

/**
 * 从定向分享发送成功
 * @param {*} mainScene 主场景
 * @param {*} otherData 其它需要打的内容
 */
DCAssist.dc4SMFShareLaunch = function(mainScene, extractmap = null) {
    let param = {
        main_scene: mainScene,
        channel_id: SHARE_CHANNEL_ID,
        is_new: _G.kIsNewUser? "1": "0",
        is_new_device: _G.kIsNewInstall? "1": "0"
    }
    if (extractmap) {
        param.extractmap = JSON.stringify(extractmap)
    }
    dc.dcShareAction("share_messege_friend", "share_enter", param);
}

/**
 * 广告曝光
 * @param {*} channelId 广告id
 */
DCAssist.dc4CustomAdPromptShow = function(channelId,  extractmap = null) {
    let param = {
        channel_id: channelId
    }
    if (extractmap) {
        param.extractmap = JSON.stringify(extractmap);
    }

    dc.dcPromotionAction("wx_promotion", "show", param);
}


/**
 * 记录AI礼包曝光
 */
DCAssist.dc4ShowAIPackages = function(param) {
    dc.dcCashGoods("package_apply", "show", param);
}

/**
 * 记录翻页AI礼包
 */
DCAssist.dc4SwapAIPackages = function(param) {
    dc.dcCashGoods("package_apply", "swap", param);
}

/**
 * 记录尝试购买AI礼包
 */
DCAssist.dc4BuyAIPackages = function(param) {
    dc.dcCashGoods("package_apply", "click", param);
}

/**
 * 记录购买AI礼包
 */
DCAssist.dc4PurchaseAIPackages = function(param) {
    dc.dcCashGoods("package_apply", "purchase", param);
}

let _gamePlayTypeV2K = null;
function playTypeValue2Key(value) {
    if (!_gamePlayTypeV2K) {
        _gamePlayTypeV2K = {}
        for(let key in GamePlayType) {
            _gamePlayTypeV2K[GamePlayType[key]] = key;
        }
    }

    return _gamePlayTypeV2K[value];
}

// 宝船点击入口按钮
DCAssist.dc4GoldTurnIconClick = function(param) {
    dc.dcGoldTurn("ad_gacha", "icon_click", param);
}

// 宝船主界面曝光
DCAssist.dc4GoldTurnPageShow = function(param) {
    dc.dcGoldTurn("ad_gacha", "page_show", param);
}

// 当对回流用户弹出回流奖励页面时
DCAssist.dc4ReturnBackShow = function(param) {
    dc.dcReturnBack("call_back", "call_back_show", param);
}

// 当回流用户领取回流奖励时
DCAssist.dc4ReturnBackClick = function(param) {
    dc.dcReturnBack("call_back", "call_back_click", param);
}

/*     @desc: 正交分组打点
    --@testId: 测试id
	--@testName: 测试名称
	--@groupId: 记录用户分组编号(1、2、3...)
	--@result: 记录用户当前是否实际被干预（满足策略条件），1是0否
    @return: nil
 */
DCAssist.dc4OrthGroup = function (testId, testName, groupId, result) {
    let params = table()
    DCAssist.dcAttackCommonData(params)
    params.test_id = testId
    params.test_name = testName
    params.num = groupId
    if (result) {
        params.type = 1
    } else {
        params.type = 0
    }
    dc.dcUserTrack_101("abtest", "test_group", DCAssist.paramsUtil(params))
}

/**
 * 冠军赛打点
 */
DCAssist.dc4ChampionClickOrShow = function (subcategory, type, data) {
    let params = table()
    // DCAssist.dcAttackCommonData(params)
    // params.subcategory = subcategory
    params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;

    if (type >= 0){
        params.type = type
    }
    if (data){
        for (const key in data) {
            params[key] = data[key]
        }
    }
    console.log("champion_race", subcategory, DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("champion_race", subcategory, DCAssist.paramsUtil(params))
    return params.session
}
/**
 * 冠军赛打点 能获得材料的关卡的关前面板曝光时
 */
DCAssist.dc4ChampionStartLevelPanelShow = function (level) {
    
    if (!ChampionLogic.getInstance().isRoomAvaliable()) {
        return
    }
    
    let params = table()
    params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
   
    // 当前关可获得材料
    // let IslandsManager = require("clover/scene/component/IslandsSystem/IslandsManager")
    // let isFullStar = IslandsManager.getInstance().isFullStar();
    let isFullStar = UserManager.getInstance().isFullStar()
    let assignlevel = ChampionLogic.getInstance().dcGetAssignLevel()

    //当前关未满星 
    let isFull = false
    let gotStar = UserScore.getInstance().getScore(level).star
    let digest = LevelConfigManager.getInstance().getLevelDigest(level)
    let starMax = $len((digest && digest.scoreTargets || table()))
    if (gotStar == starMax)
    {
        isFull = true
    }
    console.log("champion_race dctest", UserManager.getInstance().reachTopLevel(), isFullStar, level, assignlevel, UserManager.getInstance().user.topLevelId)
    //满星满关 闯神秘岛
    if (UserManager.getInstance().reachTopLevel() && isFullStar && LevelType.isMysteryIslandLevel(level) ){    
        params.type = 1
        params.current_stage = level
        console.log("champion_race", "main_page_bef_game", DCAssist.paramsUtil(params))
        dc.dcUserTrack_101("champion_race", "main_page_bef_game", DCAssist.paramsUtil(params))
        return
    }

    //满关未满星 补星或闯神秘岛
    if (UserManager.getInstance().reachTopLevel() && !isFullStar && (LevelType.isMysteryIslandLevel(level) || !isFull)) {
        params.type = 2
        params.current_stage = level
        console.log("champion_race", "main_page_bef_game", DCAssist.paramsUtil(params))
        dc.dcUserTrack_101("champion_race", "main_page_bef_game", DCAssist.paramsUtil(params))
        return
    }
    //未满关打最高关
    if (!UserManager.getInstance().reachTopLevel() && level == UserManager.getInstance().user.topLevelId){
        params.type = 0
        params.current_stage = level
        console.log("champion_race", "main_page_bef_game", DCAssist.paramsUtil(params))
        dc.dcUserTrack_101("champion_race", "main_page_bef_game", DCAssist.paramsUtil(params))
        return
    }

}
/**
 * 冠军赛获取排名材料
 */
DCAssist.dc4ChampionGetMaterial = function (level, material) {
    let params = table()
    // DCAssist.dcAttackCommonData(params)
    params.num = material
    params.current_stage = level
    // let IslandsManager = require("clover/scene/component/IslandsSystem/IslandsManager")
    // let isFullStar = IslandsManager.getInstance().isFullStar();
    let isFullStar = UserManager.getInstance().isFullStar()
    //满星满关
    if (UserManager.getInstance().reachTopLevel() && isFullStar ){    
        params.type = 1
    }

    //满关未满星
    if (UserManager.getInstance().reachTopLevel() && !isFullStar) {
        params.type = 2
    }

    //未满关
    if (!UserManager.getInstance().reachTopLevel()){
        params.type = 0
    }
    params.session = DCAssist.dcForStartGameParams.session
    console.log("champion_race", "collection", DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("champion_race", "collection", DCAssist.paramsUtil(params))
}
/**
 * 冠军赛房间
 */
DCAssist.dc4ChampionRoom = function (roomId, crownNum, stage_level, type) {
    let params = table()
    let subcategory
    if (type == 1){
        subcategory = "build_room"
    }else if (type == 2){
        subcategory = "enter_room"
    }
    params.t2 = roomId
    params.t3 = crownNum
    params.stage_level = stage_level
    console.log("champion_race", subcategory, DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("champion_race", subcategory, DCAssist.paramsUtil(params))
}

/**
 * 冠军赛等级改变
 */
DCAssist.dc4ChampionLevelChange = function (roomId, playerNum, material, lastRank, newRank) {
    let params = table()
    params.t2 = roomId
    params.num = playerNum
    params.stage_num = material
    params.pf = lastRank
    params.plt = newRank
    console.log("champion_race", "level_change", DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("champion_race", "level_change", DCAssist.paramsUtil(params))
}

/**
 * 通行证点击打点
 */
DCAssist.dc4BattlepassClick = function (subcategory, type , session) {
    let params = table()
    // DCAssist.dcAttackCommonData(params)
    // params.subcategory = subcategory
    params.session = session ? session :`${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;


    if (type){
        params.type = type
    }
    console.log("battle_pass", subcategory, DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("battle_pass", subcategory, DCAssist.paramsUtil(params))
    return params.session 
}

/**
 * 通行证展示面板打点
 */
 DCAssist.dc4BattlepassShow = function (subcategory, type) {
    let params = table()
    // DCAssist.dcAttackCommonData(params)
    // params.subcategory = subcategory
    // params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;


    if (type){
        params.type = type
    }
    console.log("battle_pass", subcategory, DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("battle_pass", subcategory, DCAssist.paramsUtil(params))
}

/**
 * 通行证领奖打点
 */
DCAssist.dc4BattlepassGetReward = function (subcategory, reward, level, type) {
    let params = table()
    params.num = level
    if (type){
        params.type = type
    }
    params.t2 = reward
    console.log("battle_pass", subcategory, DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("battle_pass", subcategory, DCAssist.paramsUtil(params))
 }

/**
 * 通行证购买结果打点
 */
DCAssist.dc4BattlepassBuyResult = function ( type ,num, session) {
    let params = table()
    // params.num = level
    // if (type){
    //     params.type = type
    // }
    // params.t2 = reward
    params.type = type
    params.num = (num - 1)
    if (session) params.session = session
    console.log("battle_pass", "buy_result", DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("battle_pass", "buy_result", DCAssist.paramsUtil(params))
}
/**
 * 通行证获得钥匙打点
 */
DCAssist.dc4BattlepassGetKey = function ( type, stage_num, current_stage, num) {
    let params = table()

    params.type = type
    params.stage_num = stage_num
    params.current_stage = current_stage
    params.num = num
    dc.dcUserTrack_101("battle_pass", "get_key", DCAssist.paramsUtil(params))
}
/**
 * 通行证增加精力上限
 */
DCAssist.dc4BattlepassAddEnergy = function (stage_num, num) {
    let params = table()

    params.stage_num = stage_num
    params.num = num
    dc.dcUserTrack_101("battle_pass", "energy", DCAssist.paramsUtil(params))
}

/**
 * 通行证奖励解锁
 */
 DCAssist.dc4BattlepassNewNode = function (num, type) {
    let params = table()

    params.type = type
    params.num = (num - 1)
    dc.dcUserTrack_101("battle_pass", "button_show", DCAssist.paramsUtil(params))
}
// 通行证结束激活购买
DCAssist.dc4BattlepassLastChanceShow = function () {
    let params = table()
    params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    dc.dcUserTrack_101("battle_pass", "last_chance_show", DCAssist.paramsUtil(params))
    return params.session
}
DCAssist.dc4BattlepassLastChanceClick = function (session, t2) {
    let params = table()
    params.session = session
    params.t2 = t2
    dc.dcUserTrack_101("battle_pass", "last_chance_click", DCAssist.paramsUtil(params))
}
// 未购买通行证玩家点击已解锁的付费奖励时
DCAssist.dc4BattlepassRewardActivate = function () {
    let params = table()
    params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    dc.dcUserTrack_101("battle_pass", "reward_activate", DCAssist.paramsUtil(params))
    return params.session
}

// 通行证 购买二次确认
DCAssist.dc4BattlepassDoubleCheck = function (session) {
    let params = table()
    params.session = session
    dc.dcUserTrack_101("battle_pass", "double_check_page_show", DCAssist.paramsUtil(params))
}
DCAssist.dc4BattlepassDoubleCheckClick = function (session,t2) {
    let params = table()
    params.session = session
    params.t2 = t2
    dc.dcUserTrack_101("battle_pass", "double_check_page_click", DCAssist.paramsUtil(params))
}

// 【category，subcategory】
const dc4AdsData = {
    "AddEnergyAd" : ["energy_ad", "ad_show"], //精力广告
    "ComplementStarAd" :  ["addstar", "ad_show"], //补星道具
    "CoinMatchAddStep" : ["battleForGold", "ad_add_step_show"], //金币大作战看广告获取更多步数
    "CoinMatchReset" : ["battleForGold", "watchAd_show"], //金币大作战看视频重置
    "CoinMatchFailAddStep" : ["battleForGold", "ad_level_show"], //金币大作战关内看广告
    "LimitBlockColloctionAddTime" : ["timeMode", "ad_show"], //限时挑战看广告加10秒
    "Remark" : ["mark", "mark_supplement_ad_show"], //补签广告
    "CashNotEnough" : ["wx_coinshort_video_ad", "show"], //金币不足面板看视频得风车币
    "MarketGetCash" : ["wx_shop_video_ad", "show"], //商店看视频得5风车币
    "FailAdd1Step" : ["plusOneMoves", "show"], //关末失败加步数
    "FailAdd2Step" : ["plusOneMoves", "show"], //关末失败加步数
    "AdGoldTurn" : ["ad_gacha", "ad_gacha_show"], //宝船看广告拿风车币
    "Startegy" : ["levelTip", "ad_show"], //查看攻略
    "MarkExtraReward" : ["mark", "mark_ad_show"], //签到广告
    "PVPTicket" : ["PVP", "ad_get_pvp_tickets_show"], //pvp看视频得门票
    "UnlockIsland" : ["island", "islandunlock_ad_show"], //看广告加速岛屿解锁
    "CoinNotEnough" : ["stage_start", "ad_getcoins_show"], //关前看视频得银币
    "AdProp" : ["stage_start", "ad_getitems_show"], //关前前置道具广告
    "AdStartProp" : ["bef_stage_ad", "ad_show"], //关前道具广告
    "AdRefreshInBattle" : ["stage", "ad_refresh_show"], //关内刷新广告
    "PassLevelDoubleReward" : ["level_bonus", "ad_show"], //关末加奖
    "AdStarDraw" : ["newchest", "ad_gacha_show"], //星星抽奖
    "AdStarDrawReset" : ["newchest", "ad_reset_show"], //星星抽奖重置奖池
    "SeasideStarDoubleCollect" : ["coast_star", "coast_star_ad_show"], //海滨之星
    "GoldMatchAddStep" : ["goldMode", "addstep_ad_show"], //夺宝大冒险加步数
    "ShipReviveAd" : ["ship_building", "ad_show"], //造船复活
    "QualifyDoubleCard" : ["main_race", "double_ad_show"], // 晋级赛 看视频获取翻倍卡
    "GetStarDiamondAd": ["star_factory", "ad_show"],// 星岛梦工厂 
    "ShopGiftItemAd": ["shop_gift_item_ad", "show"],// 商城看广告每日好礼
    "ShopGiftRefreshAd": ["shop_gift_refresh_ad", "show"],// 商城每日好礼刷新广告
    "ShopLimitRefreshAd": ["shop_limit_refresh_ad", "show"],// 商城限购刷新广告
    "BattlePassAd": ["battle_pass", "show"],// 通行证免费奖励双倍领取广告
    "FishingRodAd": ["fishing_master", "ad_show"],// 钓鱼大赛重新钓鱼广告
    "ShopGiftItemAdNew": ["free_package_ad", "show"],// 商城看广告每日好礼 新
    "ShardCollectPerDay": ["clover_festival", "free_patch_ad_show"],// 周年庆每日碎片
    "ShardCollectFreeGift": ["clover_festival", "free_package_ad_show"],// 周年庆每日碎片
    "WaterFightingAd": ["water_pvp", "ad_show"],// /水上乐斗加血广告
}
/**
 * 广告播放时
 */
DCAssist.dc4AdsShow = function (adPos,param) {
    // let params = table()
    console.log("dc4AdsShow adPos", adPos)

    if (!dc4AdsData[adPos]){
        cc.log("DCAssist.dc4AdsShow nodcdata for adPos: ", adPos)
        return
    }
    let category = dc4AdsData[adPos][0]
    let sub_category = dc4AdsData[adPos][1]
    let params = {
        ad_type: "show"
    }
    if (dc4AdsData[adPos][2]){
        let extraparams = dc4AdsData[adPos][2]
        for (let key in extraparams){
            let value = extraparams[key]
            if (!$null(value)){
                params[key] = value
            }
        }
    }

    if(param) {
        for (let key in param){
            let value = param[key]
            if (!$null(value)){
                params[key] = value
            }
        }
    }

    dc.dcUserTrack_101(category, sub_category, DCAssist.paramsUtil(params))
}
// 加载分包打点
DCAssist.dc4LoadSubPackageStart = function () {
    let params = {}
    params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    dc.dcUserTrack_101("user_load", "load_start", DCAssist.paramsUtil(params))
    return  params.session
}

DCAssist.dc4LoadSubPackageSuccess = function (session,num) {
    let params = {}
    params.session = session;
    params.num = num;
    try {
        let installKey = localStorage.getItem("_local_install_key");
        if (!installKey) {
            installKey = window.generateUUID();
            localStorage.setItem("_local_install_key", installKey);
        }
        params.installKey = installKey
    } catch (error) {
        
    }

    dc.dcUserTrack_101("user_load", "load_success", DCAssist.paramsUtil(params))
    return 
}


DCAssist.dc4LoadSubPackageFail = function (session,type) {
    let params = {}
    params.session = session;
    params.type = type;
    dc.dcUserTrack_101("user_load", "load_fail", DCAssist.paramsUtil(params))
    return 
}
DCAssist.dc4DAV2Active = function (active7, ative30) {
    let params = table()
    params.pf = active7
    params.plt = ative30
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("optimization", "falling_optimize", DCAssist.paramsUtil(params))
}

/**
 * 活动点击打点
 */
 DCAssist.dc4ActivityClick = function (category, subcategory, type, session, t3, t2, stage_num, num, bluestar) {
    let params = table()
    params.session = session || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;

    if (type){
        params.type = type
    }
    if (t3){
        params.t3 = t3
    }
    if (t2){
        params.t2 = t2
    }
    if (stage_num >= 0){
        params.stage_num = stage_num
    }
    if (num >= 0){
        params.num = num
    }
    if (bluestar >= 0){
        params.bluestar = bluestar
    }
    // console.log("dc4ActivityClick", subcategory, DCAssist.paramsUtil(params))
    dc.dcUserTrack_101(category, subcategory, DCAssist.paramsUtil(params))
    return params.session 
}


/**
 * 周年庆打点
 */
 DCAssist.dc4ShardCollect = function ( subcategory, session, param) {
    let params = table()
    params.session = session || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    // params.type = type
    // params.t2 = t2
   
    for (let key in param){
        params[key] = param[key]
    }
    // console.log("dc4ActivityPanelShow", subcategory, DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("clover_festival", subcategory, DCAssist.paramsUtil(params))
    return params.session 
}

/**
 * 点击预热期碎片选择界面确认按钮返回结果时
 */
 DCAssist.dc4ShardChoosePiece = function (idList, num, result, session) {

    for (let key in idList){
        if (!idList[key]) continue
        let params = table()
        params.session = session || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
        params.pf = idList[key]
        params.num = num
        params.result = result
        // console.log("dc4ShardChoosePiece", DCAssist.paramsUtil(params))
        dc.dcUserTrack_101("clover_festival", "patch_select_result", DCAssist.paramsUtil(params))
    
    }
        // return params.session 
}

/**
 * 玩家通过购买超值礼包界面的礼包获得奖励碎片时
 */
 DCAssist.dc4ShardChoosePieceGift = function (idList, num, t2, session) {

    for (let key in idList){
        if (!idList[key]) continue
        let params = table()
        params.session = session || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
        params.pf = idList[key]
        params.num = num
        params.t2 = t2
        // console.log("dc4ShardChoosePiece", DCAssist.paramsUtil(params))
        dc.dcUserTrack_101("clover_festival", "patch_obtain_package", DCAssist.paramsUtil(params))
    
    }
        // return params.session 
}


/**
 * 返回玩家奖励兑换结果时
 */
 DCAssist.dc4ShardExchangeResult = function (result, t2, stage_num, t3, session, pf, money, num) {
    let params = {
        result,
        t2,
        stage_num,
        t3,
        session,
        pf, 
        money,
        num
    }
    // console.log("dc4ShardExchangeResult", subcategory, DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("clover_festival", "exchange_result", DCAssist.paramsUtil(params))
    // return params.session 
}

/**
 * 岛屿引导动画
 */
DCAssist.dc4IslandGuideAni = function (subcategory, id, stars, num, session) {
    let params = table()
    params.session = session || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    // params.type = type
    // params.t2 = t2
    if (id){
        params.id = id
    }
    if (stars >= 0){
        params.stars = stars
    }
    if (num >= 0 ){
        params.num = num
    }
    // console.log("dc4ShardExchangeResult", subcategory, DCAssist.paramsUtil(params))
    dc.dcUserTrack_101("island", subcategory, DCAssist.paramsUtil(params))
    return params.session 
}

/**
 * 岛屿abtest分组
 */
DCAssist.dc4IslandABTestGroup = function (group) {
    let params = table()
    params.group = group

    dc.dcUserTrack_101("island", "ab_test_group", DCAssist.paramsUtil(params))
    // return params.session 
}
// 神秘岛 充能满打点
DCAssist.dc4MysteryChargedFull = function (levelId, levelNo, randomColor, fullTime) {
    let params = table()
    params.current_stage = levelId
    params.t1 = levelNo
    params.t2 = randomColor
    params.target_num = fullTime
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101(ModuleName.MYSTERY_ISLADN, "get_item", DCAssist.paramsUtil(params))
}
// 神秘岛 使用技能打点
DCAssist.dc4MysteryChargedRelease = function (levelId, levelNo, randomColor, fullTime) {
    let params = table()
    params.current_stage = levelId
    params.t1 = levelNo
    params.t2 = randomColor
    params.target_num = fullTime
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101(ModuleName.MYSTERY_ISLADN, "use_item", DCAssist.paramsUtil(params))
}
// 新icon面板
DCAssist.dc4NewIconPanel = function (feature) {
    let params = table()
    params.feature = feature
    params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    dc.dcUserTrack_101("user_click", "click_menu", DCAssist.paramsUtil(params))
}
// 造船
DCAssist.dc4Ship = function (subcategory, dcSession, param) {
    let params = table()
    // params.feature = feature
    params.session = dcSession || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;

    for (let key in param){
        params[key] = param[key]
    }

    dc.dcUserTrack_101("ship_building", subcategory, DCAssist.paramsUtil(params))

    return params.session
}

// 造船获得部件
DCAssist.dc4ShipBuildSuccess = function (subcategory, param) {
    let params = table()
    // params.feature = feature
    params.session = DCAssist.playLevelSession

    for (let key in param){
        params[key] = param[key]
    }

    dc.dcUserTrack_101("ship_building", subcategory, DCAssist.paramsUtil(params))

    return params.session
}

// 星岛
DCAssist.dc4StarDream = function (subcategory, dcSession, param) {
    let params = table()
    // params.feature = feature
    params.session = dcSession || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    params.current_stage = UserManager.getInstance().user.topLevelId
    for (let key in param){
        params[key] = param[key]
    }

    dc.dcUserTrack_101("star_factory", subcategory, DCAssist.paramsUtil(params))

    return params.session
}

//关内点击
DCAssist.dc4LevelSetting = function (subcategory, param) {
    let params = table()
    // params.feature = feature
    params.session = DCAssist.playLevelSession
    params.current_stage = DCAssist.dcForStartGameParams.current_stage
    params.num = DCAssist.gameLogic && DCAssist.gameLogic.getTheCurMoves()
    for (let key in param){
        params[key] = param[key]
    }

    dc.dcUserTrack_101("stage", subcategory, DCAssist.paramsUtil(params))

    // return params.session
}

DCAssist.dcForEffectEliminate = function(result){
    let params = table()
    let complete_num = 0
    if (DCAssist.gameLogic.swapMergerListD){
        complete_num = DCAssist.gameLogic.swapMergerListD[AnimalTypeConfig.kColor]
        complete_num += DCAssist.gameLogic.swapMergerListD[AnimalTypeConfig.kSuperBird]
    }
    let num = 0
    let use_num = 0
    if (DCAssist.gameLogic.swapSpecialItemList){
        num = DCAssist.gameLogic.swapSpecialItemList["5x4"]
        use_num = DCAssist.gameLogic.swapSpecialItemList["4x4"]
    }
    params.complete_num = complete_num
    params.num = num
    params.use_num = use_num

    params.result = result
    params.session = DCAssist.playLevelSession
    params.current_stage = DCAssist.dcForStartGameParams.current_stage
    params.stage_state = DCAssist.dcForStartGameParams.stage_state
    params.target_num = DCAssist.gameLogic.getDestroySpecialCount()
    // 超鸟
    if (NuclearBirdManager.getInstance().isOpenFlag){
        let nulearBirdData = NuclearBirdManager.getInstance().getData()
        params.super_bird_status = NuclearBirdManager.getInstance().isRunNuclear ? 1 :0
        params.act_id = nulearBirdData.getSeasonId()
        params.energy_level = NuclearBirdManager.getInstance().dcEnergyLevel
        params.super_bird_round = nulearBirdData.getTriggerRound()
    }

    let [dropProductSpecialList, swapMergerList2, excludeFromMixList, mixSpecial4Achievement, itemProductSpecialList] = DCAssist.gameLogic.getSpecialList()
    let squareNum1 = dropProductSpecialList[tostring(AnimalTypeConfig.kFourTile)]
    let squareNum2 = swapMergerList2[tostring(AnimalTypeConfig.kFourTile)]
    let excludeSquareNum = excludeFromMixList[tostring(AnimalTypeConfig.kFourTile)]
    let squareNum3 = mixSpecial4Achievement[tostring(AnimalTypeConfig.kFourTile)] - excludeSquareNum - squareNum2
    let squareNum4 = itemProductSpecialList[tostring(AnimalTypeConfig.kFourTile)]
    let lineNum1 = dropProductSpecialList[tostring(AnimalTypeConfig.kLine)]
    let lineNum2 = swapMergerList2[tostring(AnimalTypeConfig.kLine)]
    let excludeLineNum = excludeFromMixList[tostring(AnimalTypeConfig.kLine)]
    let lineNum3 = mixSpecial4Achievement[tostring(AnimalTypeConfig.kLine)] - excludeLineNum - lineNum2
    let lineNum4 = itemProductSpecialList[tostring(AnimalTypeConfig.kLine)]
    let boomNum1 = dropProductSpecialList[tostring(AnimalTypeConfig.kWrap)]
    let boomNum2 = swapMergerList2[tostring(AnimalTypeConfig.kWrap)]
    let excludeBoomNum = excludeFromMixList[tostring(AnimalTypeConfig.kWrap)]
    let boomNum3 = mixSpecial4Achievement[tostring(AnimalTypeConfig.kWrap)] - excludeBoomNum - boomNum2
    let boomNum4 = itemProductSpecialList[tostring(AnimalTypeConfig.kWrap)]
    let bird11 = dropProductSpecialList[tostring(AnimalTypeConfig.kColor)]
    let bird12 = swapMergerList2[tostring(AnimalTypeConfig.kColor)]
    let excludeBird1Num = excludeFromMixList[tostring(AnimalTypeConfig.kColor)]
    let bird13 = mixSpecial4Achievement[tostring(AnimalTypeConfig.kColor)] - excludeBird1Num - bird12
    let bird14 = itemProductSpecialList[tostring(AnimalTypeConfig.kColor)]
    let bird21 = dropProductSpecialList[tostring(AnimalTypeConfig.kSuperBird)]
    let bird22 = swapMergerList2[tostring(AnimalTypeConfig.kSuperBird)]
    let excludeBird2Num = excludeFromMixList[tostring(AnimalTypeConfig.kSuperBird)]
    let bird23 = mixSpecial4Achievement[tostring(AnimalTypeConfig.kSuperBird)] - excludeBird2Num - bird22
    let bird24 = itemProductSpecialList[tostring(AnimalTypeConfig.kSuperBird)]
    let bird31 = dropProductSpecialList[tostring(AnimalTypeConfig.kNuclear)]
    let bird32 = swapMergerList2[tostring(AnimalTypeConfig.kNuclear)]
    let excludeBird3Num = excludeFromMixList[tostring(AnimalTypeConfig.kNuclear)]
    let bird33 = mixSpecial4Achievement[tostring(AnimalTypeConfig.kNuclear)] - excludeBird3Num - bird32
    let bird34 = itemProductSpecialList[tostring(AnimalTypeConfig.kNuclear)]
    let t1Str = string.format("square_%d_%d_%d_%d;line_%d_%d_%d_%d;boom_%d_%d_%d_%d;bird1_%d_%d_%d_%d;bird2_%d_%d_%d_%d;bird3_%d_%d_%d_%d;", squareNum1, squareNum2, squareNum3, squareNum4, lineNum1, lineNum2, lineNum3, lineNum4, boomNum1, boomNum2, boomNum3, boomNum4, bird11, bird12, bird13, bird14, bird21, bird22, bird23, bird24, bird31, bird32, bird33, bird34)
    params.t1 = t1Str

    params.complete_num = DCAssist.gameLogic.getBirdSwapCount()
    dc.dcUserTrack_101("stage_effect", "effect_eliminate", DCAssist.paramsUtil(params))

}
DCAssist.dcForEffectGuide = function(guide_type){
    let params = table()
    params.type = guide_type
    params.current_stage = DCAssist.level
    params.session = DCAssist.playLevelSession
    params.target_num = DCAssist.gameLogic.baseMoves
    params.num = DCAssist.gameLogic.realCostMove
    dc.dcUserTrack_101("stage_effect", "effect_guide", DCAssist.paramsUtil(params))
}

// 新手礼包
DCAssist.dc4NoviceGift = function (subcategory) {
    let params = table()
    // params.feature = feature
    params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    params.current_stage = UserManager.getInstance().user.topLevelId

    dc.dcUserTrack_101("new_user_task", subcategory, DCAssist.paramsUtil(params))
}

DCAssist.dc4BagTabShow = function(tab, pf, t1, t2, t3){
	let params = table()
    var session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    params.session = session
	params.type = tab
	params.pf = pf
    params.t1 = t1
	params.plt = t2
	params.patition = t3
	DCAssist.dcAttackCommonData(params)
	dc.dcUserTrack_101("bag", "page_show", DCAssist.paramsUtil(params))
	return session
}

DCAssist.dc4BagClick = function(session, btn){
	let params = table()
    params.session = session
	params.type = btn
	DCAssist.dcAttackCommonData(params)
	dc.dcUserTrack_101("bag", "page_click", DCAssist.paramsUtil(params))
}

DCAssist.dc4BagNoteShow = function(session){
	let params = table()
	params.session = session
	DCAssist.dcAttackCommonData(params)
	dc.dcUserTrack_101("bag", "note_show", DCAssist.paramsUtil(params))
}

DCAssist.dc4SettingSmooth = function (sub_category, param) {
    let params = table()
    for (let key in param){
        params[key] = param[key]
    }
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("optimization", sub_category, DCAssist.paramsUtil(params))
}

DCAssist.dc4IslandTreasure = function(subcategory, dcSession, param){
    let params = table()
    // params.feature = feature
    params.session = dcSession || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    params.current_stage = UserManager.getInstance().user.topLevelId
    for (let key in param){
        params[key] = param[key]
    }
    params.pf =  IslandTreasureData.getInstance().alreadyBuy() ? "reward" : "buy",
    params.plt =  IslandTreasureData.getInstance().getPrice(),
    dc.dcUserTrack_101("island_treasure", subcategory, DCAssist.paramsUtil(params))

    return params.session
}


DCAssist.dc4DouyinSidebar = function(sub_category, session, type, click_type){
	let params = table()
	params.session = session
    if (type){
        params.type = type
    }
    if (click_type){
        params.click_type = click_type
    }
	DCAssist.dcAttackCommonData(params)
	dc.dcUserTrack_101("douyin_sidebar_task", sub_category, DCAssist.paramsUtil(params))
}


DCAssist.dc4LiveGift = function(subcategory, dcSession, param){
    let params = table()
    // params.feature = feature
    params.session = dcSession || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    // params.current_stage = UserManager.getInstance().user.topLevelId
    for (let key in param){
        params[key] = param[key]
    }
    // params.pf =  IslandTreasureData.getInstance().alreadyBuy() ? "reward" : "buy",
    // params.plt =  IslandTreasureData.getInstance().getPrice(),
    dc.dcUserTrack_101("limit_package", subcategory, DCAssist.paramsUtil(params))

    return params.session
}

DCAssist.waitUseFonts = {};
DCAssist.waitNoFonts = {};
DCAssist.useFontCache = {};
DCAssist.noFontCache = {};
//
DCAssist.tryLackOfFont = function (character, font) {
    let fontCache = DCAssist.noFontCache;
    let waitCache = DCAssist.waitNoFonts;
    const subcategory = "font_lack";
    const max = 5;
    if (character && font) {
        const info = dc.dcSpecialCharMapping(character);
        //
        let cb = () => {
            const waitCount = waitCache[font] ? waitCache[font].length : 0;
            if (waitCount && DCAssist.checkDcFont(fontCache[font].timestamp, waitCount, max)) {
                DCAssist.dcFont(font, waitCache[font].join(";"), subcategory);
                waitCache[font] = [];
                const newTimestamp = new Date().getTime();
                fontCache[font].timestamp = newTimestamp;
                return true;
            }
            return false;
        }
        //
        if (!fontCache[font]) {
            fontCache[font] = {
                timestamp: new Date().getTime(),
                info: true,
            };
            //5秒后剩余全部上报
            const timer = setInterval(() => {
                cb();
            }, 5000);
            fontCache[font].timer = timer;
        }
        if (!fontCache[font][info]) {
            fontCache[font][info] = true;
            if (!waitCache[font]) {
                waitCache[font] = [info];
            } else {
                waitCache[font].push(info);
            }
            cb();
        }
    }
}

DCAssist.tryUseFont = function (character, font) {
    let fontCache = DCAssist.useFontCache;
    let waitCache = DCAssist.waitUseFonts;
    const subcategory = "font_use";
    const max = 10;

    if (character && font) {
        const info = dc.dcSpecialCharMapping(character);
        //
        let cb = () => {
            const waitCount = waitCache[font] ? waitCache[font].length : 0;
            if (waitCount && DCAssist.checkDcFont(fontCache[font].timestamp, waitCount, max)) {
                DCAssist.dcFont(font, waitCache[font].join(";"), subcategory);
                waitCache[font] = [];
                const newTimestamp = new Date().getTime();
                fontCache[font].timestamp = newTimestamp;
                return true;
            }
            return false;
        }
        //
        if (!fontCache[font]) {
            fontCache[font] = {
                timestamp: new Date().getTime(),
                info: true,
            };
            //5秒后剩余全部上报
            const timer = setInterval(() => {
                cb();
            }, 5000);
            fontCache[font].timer = timer;
        }
        if (!fontCache[font][info]) {
            fontCache[font][info] = true;
            if (!waitCache[font]) {
                waitCache[font] = [info];
            } else {
                waitCache[font].push(info);
            }
            cb();
        }
    }
}

//时间戳，等待上报字数，最大等待字数，cd
DCAssist.checkDcFont = function (timestamp = 0, waitCount, max = 10, cd = 5) {
    if (waitCount >= max) {
        return true;
    }

    const newTimestamp = new Date().getTime();
    if (newTimestamp - timestamp >= cd * 1000) {
        return true;
    }

    return false;
}

DCAssist.dcFont = function (font, character, subcategory) {
    let params = table()
    params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    params.type = font
    params.info = character
    dc.dcUserTrack_101("optimization", subcategory, params)
    console.log(subcategory, font, character.split(";"));
    return params.session
}

DCAssist.dc4Encrypt = function (sub_category,method,reson,info) {
    if (!DCAssist.dc_encrypt_count) DCAssist.dc_encrypt_count = 0
    if (DCAssist.dc_encrypt_count >= 5) return 
    DCAssist.dc_encrypt_count ++

    let params = {}
    params.session = `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`
    if (info) {
        params.info =  b64Encode(JSON.stringify(info))
        // params.info = info
    }
    if (method) params.type = method;
    if (reson) params.pf = reson;

    
    cc.log("[encrypt] dc4Encrypt ",sub_category,params)
    dc.dcUserTrack_101("optimization", sub_category, DCAssist.paramsUtil(params))
    return 
}
DCAssist.dc4CircusGame = function(subcategory, dcSession, param){
    let params = table()
    // params.feature = feature
    params.session = dcSession || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;

    function convertTimestampToBeijingTime(timestamp) {
        // 创建一个以毫秒为单位的 Date 对象
        const date = new Date(timestamp);
    
        // 获取年月日时分秒
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth() + 1; // 月份从0开始，需要加1
        const day = date.getUTCDate();
        const hours = date.getUTCHours() + 8; // 北京时间比 UTC 提前8小时
        const minutes = date.getUTCMinutes();
        const seconds = date.getUTCSeconds();
    
        // 格式化输出
        return {
            year,
            month,
            day
        }
    }
    
    // 示例使用
    const timestamp = CircusGameData.getInstance().getBeginTime(); // 这是一个示例时间戳
    console.log("circus", convertTimestampToBeijingTime(timestamp));

    let time = convertTimestampToBeijingTime(timestamp)
    params.pf = time.year + "-" + time.month + "-" + time.day
    // params.current_stage = UserManager.getInstance().user.topLevelId
    for (let key in param){
        params[key] = param[key]
    }
    // params.pf =  IslandTreasureData.getInstance().alreadyBuy() ? "reward" : "buy",
    // params.plt =  IslandTreasureData.getInstance().getPrice(),
    dc.dcUserTrack_101("CircusGame", subcategory, DCAssist.paramsUtil(params))

    return params.session
}

DCAssist.dc4TTAdPay = function(subcategory, param){
    let params = table()
    params.session = param["session"] || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    for (let key in param){
        params[key] = param[key]
    }
    DCAssist.dcAttackCommonData(params)
    dc.dcUserTrack_101("douyin_ad_pay", subcategory, DCAssist.paramsUtil(params))
}


DCAssist.dc4DunkAce = function(subcategory, dcSession, param){
    let params = table()
    // params.feature = feature
    params.session = dcSession || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    // params.current_stage = UserManager.getInstance().user.topLevelId
    for (let key in param){
        params[key] = param[key]
    }
    if (!params.plt && params.plt != 0){
        let start_time = UserManager.getInstance().getSettingByKey("dunkAceSeasonStartTime", 0)
        params.plt = timestampToYMD(start_time)
    }
    if (!params.t2 && params.t2 != 0){
        params.t2 = HomeScenePopoutQueue.getInstance().getPopouDc()
    }
    // params.pf =  IslandTreasureData.getInstance().alreadyBuy() ? "reward" : "buy",
    // params.plt =  IslandTreasureData.getInstance().getPrice(),
    dc.dcUserTrack_101("DunkAce", subcategory, DCAssist.paramsUtil(params))

    return params.session
}

DCAssist.dc4Tetris = function(subcategory, dcSession, param){
    let params = table()
    // params.feature = feature
    params.session = dcSession || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    // params.current_stage = UserManager.getInstance().user.topLevelId
    for (let key in param){
        params[key] = param[key]
    }
    // params.pf =  IslandTreasureData.getInstance().alreadyBuy() ? "reward" : "buy",
    // params.plt =  IslandTreasureData.getInstance().getPrice(),
    dc.dcUserTrack_101("Tetris", subcategory, DCAssist.paramsUtil(params))

    return params.session
}
DCAssist.dc4Tetris1 = function(subcategory, dcSession, param){
    let params = table()
    // params.feature = feature
    params.session = dcSession || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    // params.current_stage = UserManager.getInstance().user.topLevelId
    for (let key in param){
        params[key] = param[key]
    }
    // params.pf =  IslandTreasureData.getInstance().alreadyBuy() ? "reward" : "buy",
    // params.plt =  IslandTreasureData.getInstance().getPrice(),
    dc.dcUserTrack_101("Tetris_activity", subcategory, DCAssist.paramsUtil(params))

    return params.session
}
DCAssist.dc4AdSkipGiftBag = function(subcategory, dcSession, param){
    let params = table()
    // params.feature = feature
    params.session = dcSession || `${UserManager.getInstance().uid}_${Localhost.timeInSec()}`;
    // params.current_stage = UserManager.getInstance().user.topLevelId
    for (let key in param){
        params[key] = param[key]
    }
    // params.pf =  IslandTreasureData.getInstance().alreadyBuy() ? "reward" : "buy",
    // params.plt =  IslandTreasureData.getInstance().getPrice(),
    dc.dcUserTrack_101("ad_free_ticket", subcategory, DCAssist.paramsUtil(params))
    return params.session
}
